<template>
  <div class="bg-white rounded-lg">
    <!--MODAL-->
    <modal v-model="alert" class="md:pb-96" :autoclose="false" title="Datos del representante legal">
      <div slot="body"
           class="grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2
            lg:grid-cols-2 xl:grid-cols-2 gap-4">
        <div>
          <inputcomponent label="Número de DUI" v-model="informacion_representante.numero_dui.value"
                          placeholder="00000000-0"
                          v-mask="'########-#'" :maxlength="9" :minlength="8" disabled
                          :errorborder="informacion_representante.numero_dui.state" required/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.numero_dui.state===true">
			          {{ informacion_representante.numero_nit.message }}
          </span>
        </div>
        <div>
          <label>¿Posee NIT? <span class="text-red-500">*</span></label>
          <div class="flex items-center space-x-4 p-3">
            <input type="radio" id="one" value="SI" v-model="poseeNIT">
            <label for="one">Sí</label>
            <input type="radio" id="two" value="NO" v-model="poseeNIT">
            <label for="two">No</label>
          </div>
        </div>
        <div v-if="poseeNIT === 'SI'">
          <inputcomponent label="Número de Identificación Tributaria (NIT)" type="text" v-model="nitrepresentante"
                          v-mask="'####-######-###-#'" @change="validData(1,'fecha_nacimiento')"
                          :errorborder="informacion_representante.numero_nit.state" :required="poseeNIT == 'SI'" ></inputcomponent>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.numero_nit.state===true && poseeNIT === 'SI'">
            {{ informacion_representante.numero_nit.message }}
          </span>
        </div>

        <div>
          <label>Primer nombre <span class="text-red-500">*</span></label>
          <input type="text" v-model="informacion_representante.primer_nombre.value" placeholder="primer nombre"
                 class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                 :class="informacion_representante.primer_nombre.state===true ? 'border-red-500':''"
                 required @change="validData(1,'primer_nombre')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.primer_nombre.state===true">
              {{ informacion_representante.primer_nombre.message }}
          </span>
        </div>

        <div>
          <label>Segundo nombre </label>
          <input type="text" v-model="informacion_representante.segundo_nombre.value" placeholder="segundo nombre"
                 class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                 :class="informacion_representante.segundo_nombre.state===true ? 'border-red-500':''"
                 required @change="validData(1,'segundo_nombre')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.segundo_nombre.state===true">
              {{ informacion_representante.segundo_nombre.message }}
        </span>
        </div>

        <div>
          <label>Tercer nombre </label>
          <input type="text" v-model="informacion_representante.tercer_nombre.value" placeholder="tercer nombre"
                 class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                 :class="informacion_representante.tercer_nombre.state===true ? 'border-red-500':''"
                 required @change="validData(1,'tercer_nombre')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.tercer_nombre.state===true">
              {{ informacion_representante.tercer_nombre.message }}
        </span>
        </div>

        <div>
          <label>Primer apellido <span class="text-red-500">*</span></label>
          <input type="text" v-model="informacion_representante.primer_apellido.value" placeholder="primer apellido"
                 class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                 :class="informacion_representante.primer_apellido.state===true ? 'border-red-500':''"
                 required @change="validData(1,'primer_apellido')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.primer_apellido.state===true">
              {{ informacion_representante.primer_apellido.message }}
          </span>
        </div>

        <div>
          <label>Segundo apellido </label>
          <input type="text" v-model="informacion_representante.segundo_apellido.value" placeholder="segundo apellido"
                 class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                 :class="informacion_representante.segundo_apellido.state===true ? 'border-red-500':''"
                 required @change="validData(1,'segundo_apellido')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.segundo_apellido.state===true">
              {{ informacion_representante.segundo_apellido.message }}
          </span>
        </div>

        <div>
          <label>Apellido casada</label>
          <input type="text" v-model="informacion_representante.apellido_casada.value" placeholder="apellido casada"
                 class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                 :class="informacion_representante.apellido_casada.state===true ? 'border-red-500':''"
                 required @change="validData(1,'apellido_casada')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.apellido_casada.state===true">
              {{ informacion_representante.apellido_casada.message }}
          </span>
        </div>

        <div>
          <inputcomponent label="Fecha nacimiento" v-model="informacion_representante.fecha_nacimiento.value"
                          placeholder="fecha nacimiento"
                          :maxDate="fecha_max" type="date"
                          :class="informacion_representante.fecha_nacimiento.state===true ? 'border-red-500 border':''"
                          required  @change="poseeNIT === 'SI' && validData(2, 'fecha_nacimiento')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.fecha_nacimiento.state===true">
              {{ informacion_representante.fecha_nacimiento.message }}
          </span>
        </div>

        <div>
          <label>Sexo <span class="text-red-500">*</span></label>
          <!--            <input  type="text" v-model="informacion_representante.sexo.value" placeholder="sexo"
                            class="block w-full py-2 pl-8 mt-2 text-textinput rounded-md appearance-none focus:outline-none focus:border-gray-200 border-gray-400 border"
                            :class="informacion_representante.sexo.state===false ? 'border-red-500':''"
                            required/>-->
          <select
            class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
            v-model="informacion_representante.sexo.value"
            required>
            <option disabled>Seleccione</option>
            <option v-for="row in sexos_options" :value="row.id" :key="row.id">{{ row.nombre }}</option>
          </select>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.sexo.state===true">
              {{ informacion_representante.sexo.message }}
          </span>
        </div>

        <div>
          <label>Nacionalidad <span class="text-red-500">*</span></label>
          <select
            class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
            v-model="informacion_representante.nacionalidad.value" disabled>
            <option v-for="row in pais_origen_options" :value="row.id" :key="row.id">{{ row.nombre }}</option>
          </select>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.nacionalidad.state===true">
              {{ informacion_representante.nacionalidad.message }}
          </span>
        </div>
      </div>

      <div slot="footer" class="grid grid-cols-2 font-bold pt-6 pb-2 gap-8">
        <button class="text-textHead uppercase focus:outline-none font-bold" @click="cancelar(2)">Cancelar</button>
        <button class="text-bodyFodes uppercase focus:outline-none font-bold" @click="registrarPersona()">Registrar
        </button>
      </div>

    </modal>

    <!--FIN MODAL-->
    <!--MODAL-->
    <modal v-model="alert_autorizado" class="md:pb-96" :autoclose="false" @close="open = false"
           title="Persona de contacto">
      <div slot="body">
        <div slot="body"
             class="text-fodesModalText grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4">
          <div>
            <label>Número de DUI *</label>
            <inputcomponent v-model="informacion_autorizado_legal.numero_dui.value" placeholder="00000000-0"
                            type="text" v-mask="'########-#'" disabled
                            :errorborder="informacion_autorizado_legal.numero_dui.state"></inputcomponent>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.numero_dui.state===true">
			          {{ informacion_autorizado_legal.numero_dui.message }}
          </span>
          </div>
          <div>
            <label>Número de Identificación Tributaria (NIT) *</label>
            <inputcomponent type="text" v-model="nitautorizado" placeholder="0000-000000-000-0"
                            :errorborder="informacion_autorizado_legal.numero_nit.state"
                            v-mask="'####-######-###-#'"
                            @change="validData(2,'fecha_nacimiento')"></inputcomponent>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.numero_nit.state===true">
			          {{ informacion_autorizado_legal.numero_nit.message }}
          </span>
          </div>
          <div>
            <label>Primer nombre *</label>
            <input type="text" v-model="informacion_autorizado_legal.primer_nombre.value" placeholder="primer nombre"
                   class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                   :class="informacion_autorizado_legal.primer_nombre.state===true ? 'border-red-500':''"
                   required @change="validData(2,'primer_nombre')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.primer_nombre.state===true">
			          {{ informacion_autorizado_legal.primer_nombre.message }}
          </span>
          </div>
          <div>
            <label>Segundo nombre </label>
            <input type="text" v-model="informacion_autorizado_legal.segundo_nombre.value" placeholder="segundo nombre"
                   class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                   :class="informacion_autorizado_legal.segundo_nombre.state===true ? 'border-red-500':''"
                   required @change="validData(2,'segundo_nombre')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.segundo_nombre.state===true">
			          {{ informacion_autorizado_legal.segundo_nombre.message }}
          </span>
          </div>
          <div>
            <label>Tercer nombre </label>
            <input type="text" v-model="informacion_autorizado_legal.tercer_nombre.value" placeholder="tercer nombre"
                   class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                   :class="informacion_autorizado_legal.tercer_nombre.state===true ? 'border-red-500':''"
                   required @change="validData(2,'tercer_nombre')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.tercer_nombre.state===true">
			          {{ informacion_autorizado_legal.tercer_nombre.message }}
          </span>
          </div>
          <div>
            <label>Primer apellido *</label>
            <input type="text" v-model="informacion_autorizado_legal.primer_apellido.value"
                   placeholder="primer apellido"
                   class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                   :class="informacion_autorizado_legal.primer_apellido.state===true ? 'border-red-500':''"
                   required @change="validData(2,'primer_apellido')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.primer_apellido.state===true">
			          {{ informacion_autorizado_legal.primer_apellido.message }}
          </span>
          </div>
          <div>
            <label>Segundo apellido </label>
            <input type="text" v-model="informacion_autorizado_legal.segundo_apellido.value"
                   placeholder="segundo apellido"
                   class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                   :class="informacion_autorizado_legal.segundo_apellido.state===true ? 'border-red-500':''"
                   required @change="validData(2,'segundo_apellido')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.segundo_apellido.state===true">
			          {{ informacion_autorizado_legal.segundo_apellido.message }}
          </span>
          </div>
          <div>
            <label>Apellido casada </label>
            <input type="text" v-model="informacion_autorizado_legal.apellido_casada.value"
                   placeholder="apellido casada"
                   class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                   :class="informacion_autorizado_legal.apellido_casada.state===true ? 'border-red-500':''"
                   required @change="validData(2,'apellido_casada')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.apellido_casada.state===true">
			          {{ informacion_autorizado_legal.apellido_casada.message }}
          </span>
          </div>
          <div>
            <label>Fecha nacimiento *</label>
            <inputcomponent type="date" v-model="informacion_autorizado_legal.fecha_nacimiento.value"
                            placeholder="fecha nacimiento" :maxDate="fecha_max"
                            :class="informacion_autorizado_legal.fecha_nacimiento.state===true ? 'border-red-500':''"
                            required @change="validData(2,'fecha_nacimiento')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.fecha_nacimiento.state===true">
			          {{ informacion_autorizado_legal.fecha_nacimiento.message }}
          </span>
          </div>
          <div>

            <label>Sexo *</label>
            <select
              class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
              v-model="informacion_autorizado_legal.sexo.value"
              required>
              <option disabled>Seleccione</option>
              <option v-for="row in sexos_options" :value="row.id" :key="row.id">{{ row.nombre }}</option>
            </select>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.sexo.state===true">
			          {{ informacion_autorizado_legal.sexo.message }}
          </span>
          </div>
          <div>
            <label>Nacionalidad *</label>
            <select
              class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
              v-model="informacion_autorizado_legal.nacionalidad.value" disabled
              required>
              <option v-for="row in pais_origen_options" :value="row.id" :key="row.id">{{ row.nombre }}</option>
              <option value="63" :selected="true">Salvadoreña</option>
            </select>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.nacionalidad.state===true">
			          {{ informacion_autorizado_legal.nacionalidad.message }}
          </span>
          </div>
        </div>
      </div>
      <!--      04802234-7-->
      <div slot="footer" class="grid grid-cols-2 font-bold py-4 pt-5 gap-8">
        <button class="text-textHead uppercase focus:outline-none font-bold" @click="cancelar(1)">Cancelar</button>
        <button class="text-bodyFodes uppercase focus:outline-none font-bold" @click="(registrarPersonaAutorizada())">
          Registrar
        </button>
      </div>
    </modal>
    <!--FIN MODAL-->
    <!--info representante legal 1-->

    <modal v-model="alert_autorizado_residente" class="md:pb-96" :autoclose="false" @close="open = false"
           title="Persona de contacto">
      <div slot="body">
        <div slot="body"
             class="text-fodesModalText grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4">
          <div>
            <label>Carnet de residente *</label>
            <inputcomponent v-model="informacion_autorizado_legal.numero_carnet.value" placeholder="Digitar numero"
                            type="text" disabled
                            :errorborder="informacion_autorizado_legal.numero_carnet.state"></inputcomponent>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.numero_carnet.state===true">
			          {{ informacion_autorizado_legal.numero_carnet.message }}
          </span>
          </div>

          <div>
            <label>Primer nombre *</label>
            <input type="text" v-model="informacion_autorizado_legal.primer_nombre.value" placeholder="primer nombre"
                   class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                   :class="informacion_autorizado_legal.primer_nombre.state===true ? 'border-red-500':''"
                   required @change="validData(2,'primer_nombre')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.primer_nombre.state===true">
			          {{ informacion_autorizado_legal.primer_nombre.message }}
          </span>
          </div>
          <div>
            <label>Segundo nombre </label>
            <input type="text" v-model="informacion_autorizado_legal.segundo_nombre.value" placeholder="segundo nombre"
                   class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                   :class="informacion_autorizado_legal.segundo_nombre.state===true ? 'border-red-500':''"
                   required @change="validData(2,'segundo_nombre')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.segundo_nombre.state===true">
			          {{ informacion_autorizado_legal.segundo_nombre.message }}
          </span>
          </div>
          <div>
            <label>Tercer nombre </label>
            <input type="text" v-model="informacion_autorizado_legal.tercer_nombre.value" placeholder="tercer nombre"
                   class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                   :class="informacion_autorizado_legal.tercer_nombre.state===true ? 'border-red-500':''"
                   required @change="validData(2,'tercer_nombre')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.tercer_nombre.state===true">
			          {{ informacion_autorizado_legal.tercer_nombre.message }}
          </span>
          </div>
          <div>
            <label>Primer apellido *</label>
            <input type="text" v-model="informacion_autorizado_legal.primer_apellido.value"
                   placeholder="primer apellido"
                   class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                   :class="informacion_autorizado_legal.primer_apellido.state===true ? 'border-red-500':''"
                   required @change="validData(2,'primer_apellido')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.primer_apellido.state===true">
			          {{ informacion_autorizado_legal.primer_apellido.message }}
          </span>
          </div>
          <div>
            <label>Segundo apellido </label>
            <input type="text" v-model="informacion_autorizado_legal.segundo_apellido.value"
                   placeholder="segundo apellido"
                   class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                   :class="informacion_autorizado_legal.segundo_apellido.state===true ? 'border-red-500':''"
                   required @change="validData(2,'segundo_apellido')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.segundo_apellido.state===true">
			          {{ informacion_autorizado_legal.segundo_apellido.message }}
          </span>
          </div>
          <div>
            <label>Apellido casada </label>
            <input type="text" v-model="informacion_autorizado_legal.apellido_casada.value"
                   placeholder="apellido casada"
                   class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                   :class="informacion_autorizado_legal.apellido_casada.state===true ? 'border-red-500':''"
                   required @change="validData(2,'apellido_casada')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.apellido_casada.state===true">
			          {{ informacion_autorizado_legal.apellido_casada.message }}
          </span>
          </div>
          <div>
            <label>Fecha nacimiento *</label>
            <inputcomponent type="date" v-model="informacion_autorizado_legal.fecha_nacimiento.value"
                            placeholder="fecha nacimiento" :maxDate="fecha_max"
                            :class="informacion_autorizado_legal.fecha_nacimiento.state===true ? 'border-red-500':''"
                            required @change="validData(2,'fecha_nacimiento')"/>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.fecha_nacimiento.state===true">
			          {{ informacion_autorizado_legal.fecha_nacimiento.message }}
          </span>
          </div>
          <div>

            <label>Sexo *</label>
            <select
              class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
              v-model="informacion_autorizado_legal.sexo.value"
              required>
              <option disabled>Seleccione</option>
              <option v-for="row in sexos_options" :value="row.id" :key="row.id">{{ row.nombre }}</option>
            </select>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.sexo.state===true">
			          {{ informacion_autorizado_legal.sexo.message }}
          </span>
          </div>
          <div>
            <label>Nacionalidad *</label>
            <select
              class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
              v-model="informacion_autorizado_legal.nacionalidad.value"
              required>
              <option v-for="row in pais_origen_options" :value="row.id" :key="row.id">{{ row.nombre }}</option>

            </select>
            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                  v-if="informacion_autorizado_legal.nacionalidad.state===true">
			          {{ informacion_autorizado_legal.nacionalidad.message }}
          </span>
          </div>
        </div>
      </div>
      <!--      04802234-7-->
      <div slot="footer" class="grid grid-cols-2 font-bold py-4 pt-5 gap-8">
        <button class="text-textHead uppercase focus:outline-none font-bold" @click="cancelar(3)">Cancelar</button>
        <button class="text-bodyFodes uppercase focus:outline-none font-bold"
                @click="(registrarPersonaAutorizadaResidente())">Registrar
        </button>
      </div>
    </modal>
    <modal v-model="alert_residente" class="md:pb-96" :autoclose="false" title="Datos del representante legal">
      <div slot="body"
           class="grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2
            lg:grid-cols-2 xl:grid-cols-2 gap-4">
        <div>
          <inputcomponent label="Carnet de residente " v-model="informacion_representante.numero_carnet.value"
                          placeholder="00000000-0"
                          :maxlength="15" disabled
                          :errorborder="informacion_representante.numero_carnet.state" required/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.numero_carnet.state===true">
			          {{ informacion_representante.numero_carnet.message }}
          </span>
        </div>
        <div>
          <label>Primer nombre <span class="text-red-500">*</span></label>
          <input type="text" v-model="informacion_representante.primer_nombre.value" placeholder="primer nombre"
                 class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                 :class="informacion_representante.primer_nombre.state===true ? 'border-red-500':''"
                 required @change="validData(1,'primer_nombre')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.primer_nombre.state===true">
              {{ informacion_representante.primer_nombre.message }}
          </span>
        </div>

        <div>
          <label>Segundo nombre </label>
          <input type="text" v-model="informacion_representante.segundo_nombre.value" placeholder="segundo nombre"
                 class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                 :class="informacion_representante.segundo_nombre.state===true ? 'border-red-500':''"
                 required @change="validData(1,'segundo_nombre')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.segundo_nombre.state===true">
              {{ informacion_representante.segundo_nombre.message }}
        </span>
        </div>

        <div>
          <label>Tercer nombre </label>
          <input type="text" v-model="informacion_representante.tercer_nombre.value" placeholder="tercer nombre"
                 class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                 :class="informacion_representante.tercer_nombre.state===true ? 'border-red-500':''"
                 required @change="validData(1,'tercer_nombre')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.tercer_nombre.state===true">
              {{ informacion_representante.tercer_nombre.message }}
        </span>
        </div>

        <div>
          <label>Primer apellido <span class="text-red-500">*</span></label>
          <input type="text" v-model="informacion_representante.primer_apellido.value" placeholder="primer apellido"
                 class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                 :class="informacion_representante.primer_apellido.state===true ? 'border-red-500':''"
                 required @change="validData(1,'primer_apellido')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.primer_apellido.state===true">
              {{ informacion_representante.primer_apellido.message }}
          </span>
        </div>

        <div>
          <label>Segundo apellido </label>
          <input type="text" v-model="informacion_representante.segundo_apellido.value" placeholder="segundo apellido"
                 class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                 :class="informacion_representante.segundo_apellido.state===true ? 'border-red-500':''"
                 required @change="validData(1,'segundo_apellido')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.segundo_apellido.state===true">
              {{ informacion_representante.segundo_apellido.message }}
          </span>
        </div>

        <div>
          <label>Apellido casada</label>
          <input type="text" v-model="informacion_representante.apellido_casada.value" placeholder="apellido casada"
                 class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
                 :class="informacion_representante.apellido_casada.state===true ? 'border-red-500':''"
                 required @change="validData(1,'apellido_casada')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.apellido_casada.state===true">
              {{ informacion_representante.apellido_casada.message }}
          </span>
        </div>

        <div>
          <inputcomponent label="Fecha nacimiento" v-model="informacion_representante.fecha_nacimiento.value"
                          placeholder="fecha nacimiento"
                          :maxDate="fecha_max" type="date"
                          :class="informacion_representante.fecha_nacimiento.state===true ? 'border-red-500 border':''"
                          required @change="validData(1,'fecha_nacimiento')"/>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.fecha_nacimiento.state===true">
              {{ informacion_representante.fecha_nacimiento.message }}
          </span>
        </div>

        <div>
          <label>Sexo <span class="text-red-500">*</span></label>
          <select
            class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
            v-model="informacion_representante.sexo.value"
            required>
            <option disabled>Seleccione</option>
            <option v-for="row in sexos_options" :value="row.id" :key="row.id">{{ row.nombre }}</option>
          </select>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.sexo.state===true">
              {{ informacion_representante.sexo.message }}
          </span>
        </div>

        <div>
          <label>Nacionalidad <span class="text-red-500">*</span></label>
          <select
            class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
            v-model="informacion_representante.nacionalidad.value">
            <option v-for="row in pais_origen_options" :value="row.id" :key="row.id">{{ row.nombre }}</option>
          </select>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante.nacionalidad.state===true">
              {{ informacion_representante.nacionalidad.message }}
          </span>
        </div>
      </div>

      <div slot="footer" class="grid grid-cols-2 font-bold pt-6 pb-2 gap-8">
        <button class="text-textHead uppercase focus:outline-none font-bold" @click="cancelar(4)">Cancelar</button>
        <button class="text-bodyFodes uppercase focus:outline-none font-bold" @click=" registrarPersonaRL()">Registrar
        </button>
      </div>

    </modal>
    <div class="divide-y divide-separatorColor mx-2 md:mx-4 pt-4">
      <p class="font-bold text-xl text-textHead pb-3.5">
        <span v-if="id_tipo_persona===1">Información de la persona natural</span>
        <span v-if="id_tipo_persona!==1">Información del representante legal</span>
      </p>
      <p></p>
    </div>

    <div class="grid xs:grid-cols-1 md:grid-cols-2 gap-4 pt-5 mx-2 md:mx-4">
      <div class="xl:col-span-1 sm:col-span-1 md:col-span-2  lg:col-span-2">
        <SelectComponent label="Tipo de documento  " :options="tipos_documentos_items"
                         :placeholder="'Seleccionar'"
                         input-value="id"
                         input-label="nombre"
                         :disabled="flagRL"
                         v-model:value="tipodocRl"
                         :@change="ShowInputsRL()"
                         required></SelectComponent>
      </div>
      <div v class="xl:col-span-1 sm:col-span-6 md:col-span-6 xs:6 lg:col-span-6"></div>
      <div v-if="mostrar_duiRL===true" class="xl:col-span-1 sm:col-span-2 md:col-span-2 xs:col-span-2 lg:col-span-2">
        <label>Número de DUI *</label>
        <inputcomponent v-mask="'########-#'" type="text" placeholder="00000000-0"
                        v-model="informacion_representante.numero_dui.value"
                        :disabled="$route.path.includes('/empresas/revision_informacion/')"
                        :errorborder="informacion_representante_props.numero_dui.state"></inputcomponent>
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              v-if="informacion_representante_props.numero_dui.state===true">
			          {{ informacion_representante_props.numero_dui.message }}
		        </span>
      </div>
      <div v-if="mostrar_residenciaRL===true"
           class="xl:col-span-1 sm:col-span-1 md:col-span-1 xs:col-span-1 lg:col-span-1">
        <inputcomponent label="Carnet de Residencia " placeholder="0000000000"
                        v-model="informacion_representante.numero_carnet.value"
                        :disabled="$route.path.includes('/empresas/revision_informacion/')"
                        @blur="verificarDocumento(informacion_representante.numero_carnet.value,4)"
                        :errorborder="informacion_representante.numero_carnet.state" required></inputcomponent>
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              v-if="informacion_representante.numero_carnet.state==true">
			          {{ informacion_representante.numero_carnet.message }}
		        </span>
      </div>
      <div v-if="mostrar_residenciaRL==true"
           class="xl:col-span-1 sm:col-span-2 md:col-span-2 xs:col-span-2 lg:col-span-2">
        <label>
          Escaneo de carnet de Residencia *
          <b v-if="informacion_representante.foto_carnet.value!==null" class="text-blue-500 pl-2">Documento ya
            cargado</b>
        </label>
        <div>
          <label
            class="inline-flex items-center block w-full py-1 px-3 mt-1 rounded-md appearance-none focus:outline-none focus:border-gray-200 border-gray-400 border"
            :class="informacion_representante.foto_carnet.state===true && informacion_representante.foto_carnet.value==null && parseInt(this.$route.params.id) !== 1 ?'focus:border-red-500 border-red-500 border':'focus:border-gray-200 border-gray-400 border'">
            <font-awesome-icon icon="paperclip"></font-awesome-icon>
            <span class="pl-3 leading-normal"
                  v-if="fotocarnet==null && informacion_representante.foto_carnet.value == null">
             {{ informacion_representante.foto_carnet.value !== null ? 'Volver' : 'Selecciona el archivo' }} a subir
             </span>
            <span class="pl-3 text-base leading-normal" v-else-if="fotocarnet!==null"><badges
              v-model="fotocarnet"></badges></span>
            <span class="pl-3 text-base leading-normal" v-else><badges value="archivo ya cargado"
                                                                              color="info"></badges></span>
            <input type='file' class="hidden" @change="fotocarnet_($event.target.files[0])"/>
          </label>
        </div>
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              v-if="informacion_representante.foto_carnet.state===true && informacion_representante.foto_carnet.value==null && parseInt(this.$route.params.id) !== 1">
			          {{ informacion_representante.foto_carnet.message }}
          </span>
      </div>

      <div v-if="mostrar_inputsRL===true" class="xl:col-span-1 sm:col-span-2 md:col-span-2 xs:col-span-2 lg:col-span-2">
        <div class="xl:col-span-1 sm:col-span-2 md:col-span-2 xs:col-span-2 lg:col-span-2">
          <label>
            Escaneo de Número de DUI *
            <b v-if="informacion_representante.foto_dui.value!==null" class="text-blue-500 pl-2">Documento ya
              cargado</b>
          </label>
          <div>
            <label
              class="inline-flex items-center block w-full py-1 px-3 mt-2 rounded-md appearance-none focus:outline-none focus:border-gray-200 border-gray-400 border"
              :class="informacion_representante_props.foto_dui.state===true && informacion_representante.foto_dui.value==null && parseInt(this.$route.params.id) !== 1 ?'focus:border-red-500 border-red-500 border':'focus:border-gray-200 border-gray-400 border'"
            >
              <font-awesome-icon icon="paperclip"></font-awesome-icon>
              <span class="pl-3 text-base leading-normal py-0.5"
                    v-if="fotodui==null && informacion_representante.foto_dui.value == null">
             {{ informacion_representante.foto_dui.value !== null ? 'Volver' : 'Selecciona el archivo' }} a subir
             </span>
              <span class="pl-3 text-base leading-normal py-0.5" v-else-if="fotodui!==null"><badges
                v-model="fotodui"></badges></span>
              <span class="pl-3 text-base leading-normal py-0.5" v-else><badges value="archivo ya cargado"
                                                                                color="info"></badges></span>
              <input type='file' class="hidden" @change="fotodui_($event.target.files[0])"/>
            </label>
          </div>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante_props.foto_dui.state===true && informacion_representante.foto_dui.value==null && parseInt(this.$route.params.id) !== 1">
			          {{ informacion_representante_props.foto_dui.message }}
          </span>
        </div>
      </div>

      <div v-if="mostrar_inputsRL===true" class="xl:col-span-1 sm:col-span-2 md:col-span-2 xs:col-span-2 lg:col-span-2">
        <label>Número de Identificación Tributaria (NIT) *</label>
        <input type="text"
       :value="(poseeNIT === 'SI' || (foundWithNit === true)) ?  nitrepresentante : informacion_representante.numero_dui.value"
       @input="e => nitrepresentante = e.target.value"

       @change="setLocalStorage_(4)"
       disabled
       class="block w-full py-2 px-3 pr-5 mt-2 text-text rounded-md appearance-none focus:outline-none border border-gray-400 focus:border-blue-500"
       :class="informacion_representante_props.numero_nit.state === true ? 'border-red-500' : ''"
       :required="poseeNIT === 'SI'"/>
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              v-if="informacion_representante_props.numero_nit.state===true">
			          {{ informacion_representante_props.numero_nit.message }}
		        </span>
      </div>
      <div v-if="mostrar_inputsRL==true" class="xl:col-span-1 sm:col-span-2 md:col-span-2 xs:col-span-2 lg:col-span-2">
        <div 
             class="xl:col-span-1 sm:col-span-2 md:col-span-2 xs:col-span-2 lg:col-span-2">
          <label>
            Escaneo de Número de Identificación Tributaria (NIT) *
            <b v-if="informacion_representante.foto_nit.value!==null" class="text-blue-500 pl-2">Documento ya
              cargado</b>
          </label>
          <div>
            <label
              class="inline-flex items-center block w-full py-1 px-3 mt-2 rounded-md appearance-none focus:outline-none focus:border-gray-200 border-gray-400 border"
              :class="informacion_representante_props.foto_nit.state===true && informacion_representante.foto_nit.value==null && parseInt(this.$route.params.id) !== 1 ?'focus:border-red-500 border-red-500 border':'focus:border-gray-200 border-gray-400 border'"
            >
              <font-awesome-icon icon="paperclip"></font-awesome-icon>
              <span class="pl-3 text-base leading-normal py-0.5"
                    v-if="fotonit==null && informacion_representante.foto_nit.value == null">
             {{ informacion_representante.foto_nit.value !== null ? 'Volver' : 'Selecciona el archivo' }} a subir
             </span>
              <span class="pl-3 text-base leading-normal py-0.5" v-else-if="fotonit!==null"><badges
                v-model="fotonit"></badges></span>
              <span class="pl-3 text-base leading-normal py-0.5" v-else><badges value="archivo ya cargado"
                                                                                color="info"></badges></span>
              <input type='file' class="hidden" @change="fotonit_($event.target.files[0])"/>
            </label>
          </div>
          <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
                v-if="informacion_representante_props.foto_nit.state===true && informacion_representante.foto_nit.value==null && parseInt(this.$route.params.id) !== 1">
			          {{ informacion_representante_props.foto_nit.message }}
          </span>
        </div>
      </div>
      <div class="xl:col-span-1 sm:col-span-2 md:col-span-2 xs:col-span-2 lg:col-span-2">
      </div>
    </div>
    <!--info del autorizado legal-->
    <div class="divide-y divide-separatorColor mx-2 md:mx-4 pt-10">
      <p class="font-bold text-2xl text-textHead pb-3.5">Información persona de contacto</p>
      <p></p>
    </div>
    <div
      class="grid grid-cols-1  sm:grid-cols-12 xl:grid-cols-12 lg:grid-cols-12 md:grid-cols-12 gap-4 pt-5 mx-2 md:mx-4">
      <div class="grid grid-cols-1  xl:col-span-6 sm:col-span-6 md:col-span-6 xs:6 lg:col-span-6">
        <SelectComponent label="Tipo de documento  " :options="tipos_documentos_items"
                         :placeholder="'Seleccionar'"
                         input-value="id"
                         input-label="nombre"
                         v-model:value="tipodoc"
                         :disabled="flag"
                         :@change="ShowInputs()"
                         required></SelectComponent>
      </div>
      <div v-if="mostrar_dui===true" class="xl:col-span-6 sm:col-span-6 md:col-span-6 xs:col-span-6 lg:col-span-6">
        <inputcomponent label="Número de DUI" v-mask="'########-#'" placeholder="00000000-0"
                        v-model="informacion_autorizado_legal.numero_dui.value"
                        :disabled="$route.path.includes('/empresas/revision_informacion/')"
                        :errorborder="informacion_autorizado_legal_props.numero_dui.state" required></inputcomponent>
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              v-if="informacion_autorizado_legal_props.numero_dui.state==true">
			          {{ informacion_autorizado_legal_props.numero_dui.message }}
		        </span>
      </div>
      <div v-if="mostrar_residencia===true"
           class="xl:col-span-6 sm:col-span-6 md:col-span-6 xs:col-span-6 lg:col-span-6">
        <inputcomponent label="Carnet de Residencia" placeholder="0000000000"
                        v-model="informacion_autorizado_legal.numero_carnet.value"
                        :disabled="$route.path.includes('/empresas/revision_informacion/')"
                        @blur="verificarDocumento(informacion_autorizado_legal.numero_carnet.value,3)"
                        :errorborder="informacion_autorizado_legal.numero_carnet.state"
                        required></inputcomponent>
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              v-if="informacion_autorizado_legal.numero_carnet.state==true">
			          {{ informacion_autorizado_legal.numero_carnet.message }}
		        </span>
      </div>
      <div v-if="mostrar_inputs===true" class="xl:col-span-6 sm:col-span-6 md:col-span-6 xs:col-span-6 lg:col-span-6">
        <inputcomponent label="Correo electrónico de persona contacto" type="text" placeholder="Correo electrónico"
                        @change="(setLocalStorage_(5),isEmailValid())"
                        v-model="informacion_autorizado_legal.correo_empresa.value"
                        :disabled="this.informacion_autorizado_legal.correo_empresa.disabled"
                        onPaste="return false;"
                        onCopy="return false;"
                        required/>


        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              v-if="informacion_autorizado_legal_props.correo_empresa.state===true">
			          {{ informacion_autorizado_legal_props.correo_empresa.message }}
        </span>
        <span class="flex items-center font-medium tracking-wide text-red-700 text-xs mt-1 ml-1"
              v-if="informacion_autorizado_legal_props.isValidEmail===false">
			          ***{{ informacion_autorizado_legal_props.isValidEmailmessage }}***
        </span>
      </div>
      <div v-if="mostrar_inputs===true" class="xl:col-span-6 sm:col-span-6 md:col-span-6 xs:col-span-6 lg:col-span-6">
        <inputcomponent label="Confirmar correo electronico" type="text" placeholder="Confirmar correo electrónico"
                        @blur="isValidEmailConfirmation()"
                        v-model="emailValue"
                        onPaste="return false;"
                        onCopy="return false;"
                        :hidden="$route.path.includes('/empresas/revision_informacion/')"
                        required/>


        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              v-if="validEmailState===true">
			          {{ validEmailMessage }}
        </span>
      </div>


      <div v-if="mostrar_inputs ===true" class="xl:col-span-5 sm:col-span-5 md:col-span-5 xs:col-span-5 lg:col-span-5">
        <inputcomponent label="Teléfonos" type="tel" v-model="numerosTelefono" placeholder="0000-0000" :maxlength="9"
                        :minlength="8" :errorborder="informacion_autorizado_legal.telefonos.state"
                        v-mask="maskTel" required/>
        <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              v-if="informacion_autorizado_legal.telefonos.state===true">
			          {{ form.nombre_empresa.message }}
		        </span>
      </div>
      <div v-if="mostrar_inputs===true" class="pt-7">
        <button type="button" @click="addTelefono(null)"
                class="px-5 py-2 focus:outline-none text-white bg-blue-500 hover:bg-blue-600 rounded-md">
          <font-awesome-icon icon="plus" class="text-white"></font-awesome-icon>
          Agregar
        </button>
      </div>

      <div v-if="mostrar_inputs===true"
           class=" xl:col-start-1 xl:col-span-6 sm:col-span-6 md:col-span-6 xs:col-span-6 lg:col-span-6">
        <tablecomponent
          :items="informacion_autorizado_legal.telefonos.value"
          :fields="fieldsNumerosTelefono">
          <template v-slot:accion="row">
            <button class="py-1 text-white bg-white focus:outline-none rounded-md"
                    @click="addTelefono(row.item,row.item.id)">
              <font-awesome-icon icon="trash" class="text-primary"></font-awesome-icon>
            </button>
          </template>
        </tablecomponent>
      </div>
    </div>
  </div>
</template>
<script>
import selectecomponent from '../../../components/selectecomponent.vue'
import Tablecomponent from '../../../components/tablecomponent.vue'
import {mapGetters} from "vuex";
import moment from 'moment';
import InputFile from "../../../components/input-file";
import SelectComponent from "../../../components/SelectComponent";

export default {
  components: {InputFile, selectecomponent, Tablecomponent, SelectComponent},
  props: {

    informacion_representante_props: {
      numero_dui: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      numero_carnet: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      foto_dui: {
        value: null,
        state: false,
        message: 'campo es requerido'
      },
      foto_carnet: {
        value: null,
        state: false,
        message: 'campo es requerido',

      },
      numero_nit: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      foto_nit: {
        value: null,
        state: false,
        message: 'campo es requerido'
      },
      primer_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      primer_apellido: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      fecha_nacimiento: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      sexo: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      cargo: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      nacionalidad: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      empresa: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      institucion: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      segundo_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      segundo_apellido: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      apellido_casada: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      tercer_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      correo_empresa: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      telefonos: {
        value: [],
        state: null,
        message: 'campo es requerido'
      },
      id_persona: 0,
      nombre: null
    },
    informacion_autorizado_legal_props: null,
    id_tipo_persona: 0
  },
  data: () => ({
    maskTel: [/[267]/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    fecha_max: new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toJSON().slice(0, 10),
    url: process.env.VUE_APP_API_URL,
    alertverification: {
      show: false,
      message: null,
      type: 'warning'
    },
    validEmailState: false,
    validEmailMessage: null,
    isValidConfirmation: false,
    emailValue: null,
    informacion_representante: {
      numero_dui: {
        value: null,
        value2: null,
        state: null,
        message: 'campo es requerido'
      },
      numero_carnet: {
        value: null,
        value2: null,
        state: null,
        message: 'campo es requerido'
      },
      foto_dui: {
        value: null,
        state: false,
        message: 'campo es requerido'
      },
      foto_carnet: {
        value: null,
        state: false,
        message: 'campo es requerido'
      },
      numero_nit: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      foto_nit: {
        value: null,
        state: false,
        message: 'campo es requerido'
      },
      primer_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      primer_apellido: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      fecha_nacimiento: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      sexo: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      cargo: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      nacionalidad: {
        value: 67,
        state: null,
        message: 'campo es requerido'
      },
      empresa: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      institucion: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      segundo_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      segundo_apellido: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      apellido_casada: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      tercer_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      id_persona: 0,
      nombre: null
    },
    informacion_autorizado_legal: {
      isValidEmail: null,
      isValidEmailmessage: null,
      numero_dui: {
        value: null,
        value2: null,
        state: null,
        message: 'campo es requerido'
      },
      numero_carnet: {
        value: null,
        value2: null,
        state: null,
        message: 'campo es requerido'
      },
      numero_nit: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      foto_nit: {
        value: null,
        state: false,
        message: 'campo es requerido'
      },
      primer_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      primer_apellido: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      fecha_nacimiento: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      sexo: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      cargo: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      nacionalidad: {
        value: 67,
        state: null,
        message: 'campo es requerido'
      },
      empresa: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      institucion: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      segundo_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      segundo_apellido: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      apellido_casada: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      tercer_nombre: {
        value: null,
        state: null,
        message: 'campo es requerido'
      },
      correo_empresa: {
        id: null,
        value: null,
        state: null,
        message: 'campo es requerido',
        disabled: false
      },
      telefonos: {
        value: [],
        state: null,
        message: 'campo es requerido'
      },
      id_persona: 0,
      nombre: null
    },
    numerosTelefono: null,
    fotonit: null,
    fotodui: null,
    fotocarnet: null,
    mostrar_inputs: false,
    mostrar_dui: false,
    mostrar_residencia: false,
    mostrar_inputsRL: false,
    mostrar_duiRL: false,
    mostrar_residenciaRL: false,
    tipos_documentos_items: [{'id': 1, 'nombre': 'DUI'}, {'id': 2, 'nombre': 'Carnet residente'}],
    tipodoc: null,
    tipodocRl: null,
    //fieldsNumerosTelefono:['Teléfono','acción'] ,
    fieldsNumerosTelefono: [{label: 'Teléfono', key: 'Telefono', class: 'text-center'}, {
      label: 'Acción',
      key: 'accion',
      class: 'text-center'
    }],
    responseDui: null,
    id_persona: 0,
    alert: false,
    alert_residente: false,
    flag: false,
    flagRL: false,
    alert_autorizado: false,
    alert_autorizado_residente: false,
    pais_origen_options: [],
    sexos_options: [],
    infoPersonaRepresentante: [],
    infoPersonaLegal: [],
    duirepresentante: null,
    nitrepresentante: null,
    duiautorizado: null,
    nitautorizado: null,
    bandera: null,
    poseeNIT: 'NO',
    foundWithNit: false,
  }),
  methods: {
    format_date(value, formato) {
      if (value) {
        return moment(String(value)).format(formato)
      }
    },
    validData(tipo, control) {
      switch (tipo) {
        case 1: // informacion_representante
          switch (control) {
            case 'primer_nombre':
              if (this.informacion_representante.primer_nombre.value !== null &&
                this.informacion_representante.primer_nombre.value !== '') {
                if (this.informacion_representante.primer_nombre.value.length > 25) {
                  this.informacion_representante.primer_nombre.message = 'Debe de ingresar hasta 25 caracteres'
                  this.informacion_representante.primer_nombre.state = true
                }
              }
              break
            case 'segundo_nombre':
              if (this.informacion_representante.segundo_nombre.value !== null &&
                this.informacion_representante.segundo_nombre.value !== '') {
                if (this.informacion_representante.segundo_nombre.value.length > 25) {
                  this.informacion_representante.segundo_nombre.message = 'Debe de ingresar hasta 25 caracteres'
                  this.informacion_representante.segundo_nombre.state = true
                }
              }
              break
            case 'tercer_nombre':
              if (this.informacion_representante.tercer_nombre.value !== null &&
                this.informacion_representante.tercer_nombre.value !== '') {
                if (this.informacion_representante.tercer_nombre.value.length > 25) {
                  this.informacion_representante.tercer_nombre.message = 'Debe de ingresar hasta 25 caracteres'
                  this.informacion_representante.tercer_nombre.state = true
                }
              }
              break
            case 'primer_apellido':
              if (this.informacion_representante.primer_apellido.value !== null &&
                this.informacion_representante.primer_apellido.value !== '') {
                if (this.informacion_representante.primer_apellido.value.length > 25) {
                  this.informacion_representante.primer_apellido.message = 'Debe de ingresar hasta 25 caracteres'
                  this.informacion_representante.primer_apellido.state = true
                }
              }
              break
            case 'segundo_apellido':
              if (this.informacion_representante.segundo_apellido.value !== null &&
                this.informacion_representante.segundo_apellido.value !== '') {
                if (this.informacion_representante.segundo_apellido.value.length > 25) {
                  this.informacion_representante.segundo_apellido.message = 'Debe de ingresar hasta 25 caracteres'
                  this.informacion_representante.segundo_apellido.state = true
                }
              }
              break
            case 'apellido_casada':
              if (this.informacion_representante.apellido_casada.value !== null &&
                this.informacion_representante.apellido_casada.value !== '') {
                if (this.informacion_representante.apellido_casada.value.length > 25) {
                  this.informacion_representante.apellido_casada.message = 'Debe de ingresar hasta 25 caracteres'
                  this.informacion_representante.apellido_casada.state = true
                }
              }
              break
            case 'fecha_nacimiento':
              if(this.poseeNIT === 'SI'){
                if (this.informacion_representante.fecha_nacimiento.value !== null &&
                    this.informacion_representante.fecha_nacimiento.value !== '' &&
                    this.informacion_representante.numero_nit.value !== null &&
                    this.informacion_representante.numero_nit.value !== '') {
                  if (this.format_date(this.informacion_representante.fecha_nacimiento.value, 'DDMMYY') !==
                      this.informacion_representante.numero_nit.value.split('-')[1]) {
                    this.informacion_representante.fecha_nacimiento.message = 'Debe de ser igual al NIT'
                    this.informacion_representante.fecha_nacimiento.state = true
                  }
                  if (this.informacion_representante.numero_nit.value.length !== 17 && this.poseeNIT ==='SI') {
                    this.informacion_representante.numero_nit.message = 'El NIT es invalido'
                    this.informacion_representante.numero_nit.state = true
                  }
                }
              }

              if(this.poseeNIT === 'NO') {
                this.informacion_representante.numero_nit.state = false;
                this.informacion_representante.numero_nit.value = this.informacion_representante.numero_dui.value;
              }

              break
          }
          break
        case 2: // informacion_autorizado_legal
          switch (control) {
            case 'primer_nombre':
              if (this.informacion_autorizado_legal.primer_nombre.value !== null &&
                this.informacion_autorizado_legal.primer_nombre.value !== '') {
                if (this.informacion_autorizado_legal.primer_nombre.value.length > 25) {
                  this.informacion_autorizado_legal.primer_nombre.message = 'Debe de ingresar hasta 25 caracteres'
                  this.informacion_autorizado_legal.primer_nombre.state = true
                }
              }
              break
            case 'segundo_nombre':
              if (this.informacion_autorizado_legal.segundo_nombre.value !== null &&
                this.informacion_autorizado_legal.segundo_nombre.value !== '') {
                if (this.informacion_autorizado_legal.segundo_nombre.value.length > 25) {
                  this.informacion_autorizado_legal.segundo_nombre.message = 'Debe de ingresar hasta 25 caracteres'
                  this.informacion_autorizado_legal.segundo_nombre.state = true
                }
              }
              break
            case 'tercer_nombre':
              if (this.informacion_autorizado_legal.tercer_nombre.value !== null &&
                this.informacion_autorizado_legal.tercer_nombre.value !== '') {
                if (this.informacion_autorizado_legal.tercer_nombre.value.length > 25) {
                  this.informacion_autorizado_legal.tercer_nombre.message = 'Debe de ingresar hasta 25 caracteres'
                  this.informacion_autorizado_legal.tercer_nombre.state = true
                }
              }
              break
            case 'primer_apellido':
              if (this.informacion_autorizado_legal.primer_apellido.value !== null &&
                this.informacion_autorizado_legal.primer_apellido.value !== '') {
                if (this.informacion_autorizado_legal.primer_apellido.value.length > 25) {
                  this.informacion_autorizado_legal.primer_apellido.message = 'Debe de ingresar hasta 25 caracteres'
                  this.informacion_autorizado_legal.primer_apellido.state = true
                }
              }
              break
            case 'segundo_apellido':
              if (this.informacion_autorizado_legal.segundo_apellido.value !== null &&
                this.informacion_autorizado_legal.segundo_apellido.value !== '') {
                if (this.informacion_autorizado_legal.segundo_apellido.value.length > 25) {
                  this.informacion_autorizado_legal.segundo_apellido.message = 'Debe de ingresar hasta 25 caracteres'
                  this.informacion_autorizado_legal.segundo_apellido.state = true
                }
              }
              break
            case 'apellido_casada':
              if (this.informacion_autorizado_legal.apellido_casada.value !== null &&
                this.informacion_autorizado_legal.apellido_casada.value !== '') {
                if (this.informacion_autorizado_legal.apellido_casada.value.length > 25) {
                  this.informacion_autorizado_legal.apellido_casada.message = 'Debe de ingresar hasta 25 caracteres'
                  this.informacion_autorizado_legal.apellido_casada.state = true
                }
              }
              break
            case 'fecha_nacimiento':
              if (this.informacion_autorizado_legal.fecha_nacimiento.value !== null &&
                this.informacion_autorizado_legal.fecha_nacimiento.value !== '' &&
                this.informacion_autorizado_legal.numero_nit.value !== null &&
                this.informacion_autorizado_legal.numero_nit.value !== '') {
                if (this.format_date(this.informacion_autorizado_legal.fecha_nacimiento.value, 'DDMMYY') !==
                  this.informacion_autorizado_legal.numero_nit.value.split('-')[1]) {
                  this.informacion_autorizado_legal.fecha_nacimiento.message = 'Debe de ser igual al NIT'
                  this.informacion_autorizado_legal.fecha_nacimiento.state = true
                }
                if (this.informacion_autorizado_legal.numero_nit.value.length !== 17) {
                  this.informacion_autorizado_legal.numero_nit.message = 'El NIT es invalido'
                  this.informacion_autorizado_legal.numero_nit.state = true
                }
              }
              break
          }
          break
      }
    },
    cancelar(tipo) {
      if (tipo === 1) {

        this.duiautorizado = null

        this.informacion_autorizado_legal.numero_dui.value = null
        this.alert_autorizado = false
        this.setLocalStorage_(5)

      }
      if (tipo === 2) {

        this.duirepresentante = null
        this.informacion_representante.numero_dui.value = null
        this.informacion_representante.numero_carnet.value = null
        this.alert = false
        this.setLocalStorage_(4)
      }
      if (tipo === 3) {

        this.informacion_autorizado_legal.numero_carnet.value = null
        this.alert_autorizado_residente = false
        this.setLocalStorage_(5)
      }
      if (tipo === 4) {

        this.informacion_representante.numero_carnet.value = null
        this.setLocalStorage_(5)
        this.alert_residente = false

      }
    },
    isEmailValid() {
      let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
      return (this.informacion_autorizado_legal.correo_empresa.value == "" || this.informacion_autorizado_legal.correo_empresa.value == null)
        ? "" : (reg.test(this.informacion_autorizado_legal.correo_empresa.value))
          ? ('border-green-500', this.informacion_autorizado_legal.isValidEmail = true, this.informacion_autorizado_legal.isValidEmail == null ? '' : this.setLocalStorage_(5))
          : ('border-red-300', this.informacion_autorizado_legal.isValidEmail = false,
            this.informacion_autorizado_legal.isValidEmailmessage = 'email invalido', this.setLocalStorage_(5));
    },

    async isValidEmailConfirmation() {

      let email = this.informacion_autorizado_legal.correo_empresa.value;
      let emailConfirm = this.emailValue
      if (email !== emailConfirm) {
        this.validEmailState = true;
        this.validEmailMessage = "El correo no coincide, por favor validar antes de seguir."
      } else {
        this.isValidConfirmation = true
        this.validEmailState = false
        this.validEmailMessage = null

        window.localStorage.setItem('isValidConfirmation', JSON.stringify(this.isValidConfirmation));

      }
    },
    registrarPersona() {
      let headers = null

      if (this.$route.path.includes('/empresas/revision_informacion/')) {
        headers = {Authorization: 'Bearer ' + window.localStorage.getItem('token')}
      }

      let id = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
      this.informacion_representante.empresa.value = id.id


      this.informacion_representante.primer_nombre.state = false
      this.informacion_representante.segundo_nombre.state = false
      this.informacion_representante.tercer_nombre.state = false
      this.informacion_representante.primer_apellido.state = false
      this.informacion_representante.segundo_apellido.state = false
      this.informacion_representante.apellido_casada.state = false
      this.informacion_representante.fecha_nacimiento.state = false
      this.validData(1, 'primer_nombre')
      this.validData(1, 'segundo_nombre')
      this.validData(1, 'tercer_nombre')
      this.validData(1, 'primer_apellido')
      this.validData(1, 'segundo_apellido')
      this.validData(1, 'apellido_casada')
      this.validData(1, 'fecha_nacimiento')

      if (this.informacion_representante.primer_nombre.value !== null
        && !this.informacion_representante.primer_nombre.state
        && !this.informacion_representante.segundo_nombre.state
        && !this.informacion_representante.tercer_nombre.state
        && !this.informacion_representante.primer_apellido.state
        && !this.informacion_representante.segundo_apellido.state
        && !this.informacion_representante.apellido_casada.state
        && !this.informacion_representante.fecha_nacimiento.state
        && this.informacion_representante.primer_apellido.value !== null
        && this.informacion_representante.nacionalidad.value !== null
        && this.informacion_representante.numero_dui.value !== null
        && ((this.poseeNIT === 'SI' && this.informacion_representante.numero_nit.value !== null) || (this.poseeNIT === 'NO' && this.informacion_representante.numero_nit.value !== null) )
        && this.informacion_representante.sexo.value !== null
        && this.informacion_representante.primer_nombre.value !== ''
        && this.informacion_representante.primer_apellido.value !== ''
        && this.informacion_representante.nacionalidad.value !== ''
        && this.informacion_representante.numero_dui.value !== ''
        && this.informacion_representante.sexo.value !== ''
        && this.informacion_representante.numero_nit.value !== ''
        && this.informacion_representante.fecha_nacimiento.value !== ''
        && this.informacion_representante.fecha_nacimiento.value !== null) {


        if (this.informacion_representante.primer_nombre.value.length > 24) {
          this.$toast.error('Longitud de primer nombre menor a 25')
          return false

        }
        if (this.informacion_representante.segundo_nombre.value !== null && this.informacion_representante.segundo_nombre.value !== '') {
          if (this.informacion_representante.segundo_nombre.value.length > 24) {
            this.$toast.error('Longitud de segundo nombre menor a 25')
            return false
          }
        }
        if (this.informacion_representante.tercer_nombre.value !== null && this.informacion_representante.tercer_nombre.value !== '') {
          if (this.informacion_representante.tercer_nombre.value.length > 24) {
            this.$toast.error('Longitud de tercer nombre menor a 25')
            return false
          }
        }
        if (this.informacion_representante.primer_apellido.value.length > 24) {
          this.$toast.error('Longitud de primer apellido menor a 25')
          return false

        }
        if (this.informacion_representante.segundo_apellido.value !== null && this.informacion_representante.segundo_apellido.value !== '') {
          if (this.informacion_representante.segundo_apellido.value.length > 24) {
            this.$toast.error('Longitud de segundo apellido menor a 25')
            return false
          }
        }

        if (this.informacion_representante.apellido_casada.value !== null && this.informacion_representante.apellido_casada.value !== '') {
          if (this.informacion_representante.apellido_casada.value.length > 24) {
            this.$toast.error('Longitud de apellido de casada menor a 25')
            return false
          }
        }


        let today = new Date();
        today.setFullYear(today.getFullYear() - 18);
        let birthdate_format = new Date(this.informacion_representante.fecha_nacimiento.value);
        if (birthdate_format > today) {
          this.$toast.error('El representante debe ser mayor de edad')
          return false

        } else {


          let nit_date = this.informacion_representante.numero_nit.value;
          let birthdate = this.informacion_representante.fecha_nacimiento.value;
          let date1 = birthdate.substr(8, 2) + birthdate.substr(5, 2) + birthdate.substr(2, 2);
          let date2 = nit_date.substr(5, 6);
          if (date1 !== date2 && this.poseeNIT ==='SI') {
            this.$toast.error('Fecha de nacimiento no coincide con el NIT')
            return false
          } else {
            axios.post(this.url + '/api/v1/personas', {
              "primer_nombre": this.informacion_representante.primer_nombre.value,
              "primer_apellido": this.informacion_representante.primer_apellido.value,
              "fecha_nacimiento": this.informacion_representante.fecha_nacimiento.value,
              "id_sexo": parseInt(this.informacion_representante.sexo.value),
              "id_nacionalidad": parseInt(this.informacion_representante.nacionalidad.value),
              "id_cargo": 1,
              "activo": true,
              "id_empresa": id.id,
              //"id_institucion":id.id,
              "segundo_nombre": this.informacion_representante.segundo_nombre.value !== null && this.informacion_representante.segundo_nombre.value !== ''
              && this.informacion_representante.segundo_nombre.value.length > 0 ? this.informacion_representante.segundo_nombre.value : null,
              "segundo_apellido": this.informacion_representante.segundo_apellido.value !== null && this.informacion_representante.segundo_apellido.value !== ''
              && this.informacion_representante.segundo_apellido.value.length > 0 ? this.informacion_representante.segundo_apellido.value : null,
              "apellido_casada": this.informacion_representante.apellido_casada.value !== null && this.informacion_representante.apellido_casada.value !== '' ? this.informacion_representante.apellido_casada.value : null,
              "tercer_nombre": this.informacion_representante.tercer_nombre.value !== null && this.informacion_representante.tercer_nombre.value !== '' ? this.informacion_representante.tercer_nombre.value : null,
              "dui": this.informacion_representante.numero_dui.value,
              "nit": this.poseeNIT === 'SI' ? this.informacion_representante.numero_nit.value : this.informacion_representante.numero_dui.value
            }, {headers}).then((response) => {
              if (response.status == 303) {
                this.$toast.error('El numero de NIT ya se encuentra asociado a otra persona')
              } else {
                this.informacion_representante.numero_dui.value = response.data.dui,
                  this.duirepresentante = response.data.dui
                this.informacion_representante.numero_nit.value = response.data.nit,
                  this.informacion_representante.primer_nombre.value = response.data.primer_nombre,
                  this.informacion_representante.segundo_nombre.value = response.data.segundo_nombre,
                  this.informacion_representante.segundo_apellido.value = response.data.segundo_apellido,
                  this.informacion_representante.tercer_nombre.value = response.data.tercer_nombre,
                  this.informacion_representante.apellido_casada.value = response.data.apellido_casada,
                  this.informacion_representante.nacionalidad.value = response.data.id_nacionalidad,
                  this.informacion_representante.sexo.value = response.data.id_sexo,
                  this.informacion_representante.cargo.value = 1,
                  this.informacion_representante.empresa.value = this.informacion_representante.empresa.value,
                  this.informacion_representante.id_persona = response.data.id,
                  this.setLocalStorage_(4)
                this.bandera = true
                this.alert = false
              }
            }).catch(error => {
              if (error.response.status == 303) {
                this.$toast.error('El numero de NIT ya se encuentra asociado a otra persona')
              }
              if (error.response.status == 400) {
                this.$toast.error(error.response.data.message)
              }
              error.response.data.errors.forEach(row => {
                if (row.propiedad == 'nit') {
                  this.$toast.error('Error en el nit verifique la información ingresada')
                }
              })
              return false;
            })
          }
        }
      } else {
        this.informacion_representante.numero_dui.value == null ||
        this.informacion_representante.numero_dui.value == '' ? this.informacion_representante.numero_dui.state = true
          : this.informacion_representante.numero_dui.state = false

        this.informacion_representante.primer_nombre.value == null ||
        this.informacion_representante.primer_nombre.value == '' ? this.informacion_representante.primer_nombre.state = true
          : this.informacion_representante.primer_nombre.state = false

        this.informacion_representante.segundo_nombre.value == null ||
        this.informacion_representante.segundo_nombre.value == '' ? this.informacion_representante.segundo_nombre.state = false
          : this.informacion_representante.segundo_nombre.state = false

        this.informacion_representante.primer_apellido.value == null ||
        this.informacion_representante.primer_apellido.value == '' ? this.informacion_representante.primer_apellido.state = true
          : this.informacion_representante.primer_apellido.state = false

        this.informacion_representante.segundo_apellido.value == null ||
        this.informacion_representante.segundo_apellido.value == '' ? this.informacion_representante.segundo_apellido.state = false
          : this.informacion_representante.segundo_apellido.state = false

        this.informacion_representante.numero_nit.value == null ||
        this.informacion_representante.numero_nit.value == '' ? this.informacion_representante.numero_nit.state = true
          : this.informacion_representante.numero_nit.state = false

        this.informacion_representante.numero_dui.value == null ||
        this.informacion_representante.numero_dui.value == '' ? this.informacion_representante.numero_dui.state = true
          : this.informacion_representante.numero_dui.state = false

        this.informacion_representante.nacionalidad.value == null ||
        this.informacion_representante.nacionalidad.value == '' ? this.informacion_representante.nacionalidad.state = true
          : this.informacion_representante.nacionalidad.state = false

        this.informacion_representante.sexo.value == null ||
        this.informacion_representante.sexo.value == '' ? this.informacion_representante.sexo.state = true
          : this.informacion_representante.sexo.state = false

        this.informacion_representante.fecha_nacimiento.value == null ||
        this.informacion_representante.fecha_nacimiento.value == '' ? this.informacion_representante.fecha_nacimiento.state = true
          : this.informacion_representante.fecha_nacimiento.state = false

        this.validData(1, 'primer_nombre')
        this.validData(1, 'segundo_nombre')
        this.validData(1, 'tercer_nombre')
        this.validData(1, 'primer_apellido')
        this.validData(1, 'segundo_apellido')
        this.validData(1, 'apellido_casada')
        this.validData(1, 'fecha_nacimiento')
      }
    },
    registrarPersonaRL() {
      let headers = null

      if (this.$route.path.includes('/empresas/revision_informacion/')) {
        headers = {Authorization: 'Bearer ' + window.localStorage.getItem('token')}
      }

      let id = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
      this.informacion_representante.empresa.value = id.id


      this.informacion_representante.primer_nombre.state = false
      this.informacion_representante.segundo_nombre.state = false
      this.informacion_representante.tercer_nombre.state = false
      this.informacion_representante.primer_apellido.state = false
      this.informacion_representante.segundo_apellido.state = false
      this.informacion_representante.apellido_casada.state = false
      this.informacion_representante.fecha_nacimiento.state = false
      this.validData(1, 'primer_nombre')
      this.validData(1, 'segundo_nombre')
      this.validData(1, 'tercer_nombre')
      this.validData(1, 'primer_apellido')
      this.validData(1, 'segundo_apellido')
      this.validData(1, 'apellido_casada')
      //this.validData(1,'fecha_nacimiento')

      if (this.informacion_representante.primer_nombre.value !== null
        && !this.informacion_representante.primer_nombre.state
        && !this.informacion_representante.segundo_nombre.state
        && !this.informacion_representante.tercer_nombre.state
        && !this.informacion_representante.primer_apellido.state
        && !this.informacion_representante.segundo_apellido.state
        && !this.informacion_representante.apellido_casada.state
        && !this.informacion_representante.fecha_nacimiento.state
        && this.informacion_representante.primer_apellido.value !== null
        && this.informacion_representante.nacionalidad.value !== null
        && this.informacion_representante.sexo.value !== null
        && this.informacion_representante.numero_carnet.value !== null
        && this.informacion_representante.primer_nombre.value !== ''
        && this.informacion_representante.primer_apellido.value !== ''
        && this.informacion_representante.nacionalidad.value !== ''
        && this.informacion_representante.sexo.value !== ''
        && this.informacion_representante.numero_carnet.value !== ''
        && this.informacion_representante.fecha_nacimiento.value !== ''
        && this.informacion_representante.fecha_nacimiento.value !== null) {


        if (this.informacion_representante.primer_nombre.value.length > 24) {
          this.$toast.error('Longitud de primer nombre menor a 25')
          return false

        }
        if (this.informacion_representante.segundo_nombre.value !== null && this.informacion_representante.segundo_nombre.value !== '') {
          if (this.informacion_representante.segundo_nombre.value.length > 24) {
            this.$toast.error('Longitud de segundo nombre menor a 25')
            return false
          }
        }
        if (this.informacion_representante.tercer_nombre.value !== null && this.informacion_representante.tercer_nombre.value !== '') {
          if (this.informacion_representante.tercer_nombre.value.length > 24) {
            this.$toast.error('Longitud de tercer nombre menor a 25')
            return false
          }
        }
        if (this.informacion_representante.primer_apellido.value.length > 24) {
          this.$toast.error('Longitud de primer apellido menor a 25')
          return false

        }
        if (this.informacion_representante.segundo_apellido.value !== null && this.informacion_representante.segundo_apellido.value !== '') {
          if (this.informacion_representante.segundo_apellido.value.length > 24) {
            this.$toast.error('Longitud de segundo apellido menor a 25')
            return false
          }
        }

        if (this.informacion_representante.apellido_casada.value !== null && this.informacion_representante.apellido_casada.value !== '') {
          if (this.informacion_representante.apellido_casada.value.length > 24) {
            this.$toast.error('Longitud de apellido de casada menor a 25')
            return false
          }
        }


        let today = new Date();
        today.setFullYear(today.getFullYear() - 18);
        let birthdate_format = new Date(this.informacion_representante.fecha_nacimiento.value);
        if (birthdate_format > today) {
          this.$toast.error('El representante debe ser mayor de edad')
          return false

        } else {


          let nit_date = this.informacion_representante.numero_nit.value;
          let birthdate = this.informacion_representante.fecha_nacimiento.value;


          axios.post(this.url + '/api/v1/personas', {
            "primer_nombre": this.informacion_representante.primer_nombre.value,
            "primer_apellido": this.informacion_representante.primer_apellido.value,
            "fecha_nacimiento": this.informacion_representante.fecha_nacimiento.value,
            "id_sexo": parseInt(this.informacion_representante.sexo.value),
            "id_nacionalidad": parseInt(this.informacion_representante.nacionalidad.value),
            "id_cargo": 1,
            "activo": true,
            "id_empresa": id.id,
            //"id_institucion":id.id,
            "segundo_nombre": this.informacion_representante.segundo_nombre.value !== null && this.informacion_representante.segundo_nombre.value !== ''
            && this.informacion_representante.segundo_nombre.value.length > 0 ? this.informacion_representante.segundo_nombre.value : null,
            "segundo_apellido": this.informacion_representante.segundo_apellido.value !== null && this.informacion_representante.segundo_apellido.value !== ''
            && this.informacion_representante.segundo_apellido.value.length > 0 ? this.informacion_representante.segundo_apellido.value : null,
            "apellido_casada": this.informacion_representante.apellido_casada.value !== null && this.informacion_representante.apellido_casada.value !== '' ? this.informacion_representante.apellido_casada.value : null,
            "tercer_nombre": this.informacion_representante.tercer_nombre.value !== null && this.informacion_representante.tercer_nombre.value !== '' ? this.informacion_representante.tercer_nombre.value : null,
            "dui": this.informacion_representante.numero_dui.value ? this.informacion_representante.numero_dui.value : null,
            "nit": this.informacion_representante.numero_nit.value ? this.informacion_representante.numero_dui.value : null,
            "carne_residente": this.informacion_representante.numero_carnet.value ? this.informacion_representante.numero_carnet.value : null,
          }, {headers}).then((response) => {
            if (response.status == 303) {
              this.$toast.error('El numero de NIT ya se encuentra asociado a otra persona')
            } else {
              this.informacion_representante.numero_carnet.value = response.data.carnet_residente,
                // this.duirepresentante = response.data.dui
                this.informacion_representante.numero_nit.value = response.data.nit,
                this.informacion_representante.primer_nombre.value = response.data.primer_nombre,
                this.informacion_representante.segundo_nombre.value = response.data.segundo_nombre,
                this.informacion_representante.segundo_apellido.value = response.data.segundo_apellido,
                this.informacion_representante.tercer_nombre.value = response.data.tercer_nombre,
                this.informacion_representante.apellido_casada.value = response.data.apellido_casada,
                this.informacion_representante.nacionalidad.value = response.data.id_nacionalidad,
                this.informacion_representante.sexo.value = response.data.id_sexo,
                this.informacion_representante.cargo.value = 1,
                this.informacion_representante.empresa.value = this.informacion_representante.empresa.value,
                this.informacion_representante.id_persona = response.data.id,
                this.setLocalStorage_(4)
              this.bandera = true
              this.alert_residente = false
            }
          }).catch(error => {
            if (error.response.status == 303) {
              this.$toast.error('El numero de NIT ya se encuentra asociado a otra persona')
            }

            if (error.response.status == 400) {
              this.$toast.error(error.response.data.message)
            }
            error.response.data.errors.forEach(row => {
              if (row.propiedad == 'nit') {
                this.$toast.error('Error en el nit verifique la información ingresada')
              }
            })
            return false;
          })

        }
      } else {
        this.informacion_representante.numero_carnet.value == null ||
        this.informacion_representante.numero_carnet.value == '' ? this.informacion_representante.numero_carnet.state = true
          : this.informacion_representante.numero_carnet.state = false

        this.informacion_representante.primer_nombre.value == null ||
        this.informacion_representante.primer_nombre.value == '' ? this.informacion_representante.primer_nombre.state = true
          : this.informacion_representante.primer_nombre.state = false

        this.informacion_representante.segundo_nombre.value == null ||
        this.informacion_representante.segundo_nombre.value == '' ? this.informacion_representante.segundo_nombre.state = false
          : this.informacion_representante.segundo_nombre.state = false

        this.informacion_representante.primer_apellido.value == null ||
        this.informacion_representante.primer_apellido.value == '' ? this.informacion_representante.primer_apellido.state = true
          : this.informacion_representante.primer_apellido.state = false

        this.informacion_representante.segundo_apellido.value == null ||
        this.informacion_representante.segundo_apellido.value == '' ? this.informacion_representante.segundo_apellido.state = false
          : this.informacion_representante.segundo_apellido.state = false


        this.informacion_representante.numero_carnet.value == null ||
        this.informacion_representante.numero_carnet.value == '' ? this.informacion_representante.numero_carnet.state = true
          : this.informacion_representante.numero_carnet.state = false

        this.informacion_representante.nacionalidad.value == null ||
        this.informacion_representante.nacionalidad.value == '' ? this.informacion_representante.nacionalidad.state = true
          : this.informacion_representante.nacionalidad.state = false

        this.informacion_representante.sexo.value == null ||
        this.informacion_representante.sexo.value == '' ? this.informacion_representante.sexo.state = true
          : this.informacion_representante.sexo.state = false

        this.informacion_representante.fecha_nacimiento.value == null ||
        this.informacion_representante.fecha_nacimiento.value == '' ? this.informacion_representante.fecha_nacimiento.state = true
          : this.informacion_representante.fecha_nacimiento.state = false

        this.validData(1, 'primer_nombre')
        this.validData(1, 'segundo_nombre')
        this.validData(1, 'tercer_nombre')
        this.validData(1, 'primer_apellido')
        this.validData(1, 'segundo_apellido')
        this.validData(1, 'apellido_casada')
        // this.validData(1,'fecha_nacimiento')
      }
    },
    registrarPersonaAutorizada() {
      this.informacion_autorizado_legal.primer_nombre.state = false
      this.informacion_autorizado_legal.segundo_nombre.state = false
      this.informacion_autorizado_legal.tercer_nombre.state = false
      this.informacion_autorizado_legal.primer_apellido.state = false
      this.informacion_autorizado_legal.segundo_apellido.state = false
      this.informacion_autorizado_legal.apellido_casada.state = false
      this.informacion_autorizado_legal.fecha_nacimiento.state = false
      this.validData(2, 'primer_nombre')
      this.validData(2, 'segundo_nombre')
      this.validData(2, 'tercer_nombre')
      this.validData(2, 'primer_apellido')
      this.validData(2, 'segundo_apellido')
      this.validData(2, 'apellido_casada')
      this.validData(2, 'fecha_nacimiento')
      if (this.informacion_autorizado_legal.primer_nombre.value !== null
        && !this.informacion_autorizado_legal.primer_nombre.state
        && !this.informacion_autorizado_legal.segundo_nombre.state
        && !this.informacion_autorizado_legal.tercer_nombre.state
        && !this.informacion_autorizado_legal.primer_apellido.state
        && !this.informacion_autorizado_legal.segundo_apellido.state
        && !this.informacion_autorizado_legal.apellido_casada.state
        && !this.informacion_autorizado_legal.fecha_nacimiento.state
        && this.informacion_autorizado_legal.primer_apellido.value !== null
        && this.informacion_autorizado_legal.nacionalidad.value !== null
        && this.informacion_autorizado_legal.numero_dui.value !== null
        && this.informacion_autorizado_legal.numero_nit.value !== null
        && this.informacion_autorizado_legal.sexo.value !== null
        && this.informacion_autorizado_legal.fecha_nacimiento.value !== null
        && this.informacion_autorizado_legal.primer_nombre.value !== ''
        && this.informacion_autorizado_legal.primer_apellido.value !== ''
        && this.informacion_autorizado_legal.nacionalidad.value !== ''
        && this.informacion_autorizado_legal.fecha_nacimiento.value !== ''
        && this.informacion_autorizado_legal.sexo.value !== ''
        && this.informacion_autorizado_legal.numero_dui.value !== ''
        && this.informacion_autorizado_legal.numero_nit.value !== '') {
        let id = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
        axios.post(this.url + '/api/v1/personas', {
          "primer_nombre": this.informacion_autorizado_legal.primer_nombre.value,
          "primer_apellido": this.informacion_autorizado_legal.primer_apellido.value,
          "fecha_nacimiento": this.informacion_autorizado_legal.fecha_nacimiento.value,
          "id_sexo": parseInt(this.informacion_autorizado_legal.sexo.value),
          "id_nacionalidad": parseInt(this.informacion_autorizado_legal.nacionalidad.value),
          "id_cargo": 2,
          "activo": true,
          //  "id_institucion": parseInt(id.id),
          "segundo_nombre": this.informacion_autorizado_legal.segundo_nombre.value !== null && this.informacion_autorizado_legal.segundo_nombre.value !== '' &&
          this.informacion_autorizado_legal.segundo_nombre.value.length > 0 ? this.informacion_autorizado_legal.segundo_nombre.value : null,
          "segundo_apellido": this.informacion_autorizado_legal.segundo_apellido.value !== null && this.informacion_autorizado_legal.segundo_apellido.value !== '' &&
          this.informacion_autorizado_legal.segundo_apellido.value.length > 0 ? this.informacion_autorizado_legal.segundo_apellido.value : null,
          "apellido_casada": this.informacion_autorizado_legal.apellido_casada.value <= 0 ? null : this.informacion_autorizado_legal.apellido_casada.value,
          "dui": this.informacion_autorizado_legal.numero_dui.value ? this.informacion_autorizado_legal.numero_dui.value : null,
          "tercer_nombre": this.informacion_autorizado_legal.tercer_nombre.value <= 0 ? null : this.informacion_autorizado_legal.tercer_nombre.value,
          "nit": this.informacion_autorizado_legal.numero_nit.value ? this.informacion_autorizado_legal.numero_nit.value : null,
          "carne_residente": this.informacion_autorizado_legal.numero_carnet.value ? this.informacion_autorizado_legal.numero_carnet.value : null,
        }).then((response) => {
          if (response.status == 303) {
            this.$toast.error('El numero de NIT ya se encuentra asociado a otra persona')
          } else {
            this.informacion_autorizado_legal.numero_dui.value = response.data.dui,
              this.informacion_autorizado_legal.numero_nit.value = response.data.nit,
              this.informacion_autorizado_legal.primer_nombre.value = response.data.primer_nombre,
              this.informacion_autorizado_legal.segundo_nombre.value = response.data.segundo_nombre,
              this.informacion_autorizado_legal.segundo_apellido.value = response.data.segundo_apellido,
              this.informacion_autorizado_legal.tercer_nombre.value = response.data.tercer_nombre,
              this.informacion_autorizado_legal.apellido_casada.value = response.data.apellido_casada,
              this.informacion_autorizado_legal.nacionalidad.value = response.data.id_nacionalidad,
              this.informacion_autorizado_legal.sexo.value = response.data.id_sexo,
              this.informacion_autorizado_legal.cargo.value = 1,
              this.informacion_autorizado_legal.empresa.value = this.informacion_representante.empresa.value,
              this.informacion_autorizado_legal.id_persona = response.data.id,
              this.setLocalStorage_(5)
            this.alert_autorizado = false
          }
        }).catch(error => {
          if (error.response.status == 303) {
            this.$toast.error('El numero de NIT ya se encuentra asociado a otra persona')
          }
          if (error.response.status == 400) {
            this.$toast.error(error.response.data.message)
          }
          error.response.data.errors.forEach(row => {
            if (row.propiedad == 'nit') {
              this.$toast.error('Error en el nit verifique la información ingresada')
            }
          })
          return false;
        })
      } else {
        this.informacion_autorizado_legal.numero_dui.value == null ||
        this.informacion_autorizado_legal.numero_dui.value == '' ? this.informacion_autorizado_legal.numero_dui.state = true
          : this.informacion_autorizado_legal.numero_dui.state = false

        this.informacion_autorizado_legal.primer_nombre.value == null ||
        this.informacion_autorizado_legal.primer_nombre.value == '' ? this.informacion_autorizado_legal.primer_nombre.state = true
          : this.informacion_autorizado_legal.primer_nombre.state = false


        this.informacion_autorizado_legal.primer_apellido.value == null ||
        this.informacion_autorizado_legal.primer_apellido.value == '' ? this.informacion_autorizado_legal.primer_apellido.state = true
          : this.informacion_autorizado_legal.primer_apellido.state = false


        this.informacion_autorizado_legal.numero_nit.value == null ||
        this.informacion_autorizado_legal.numero_nit.value == '' ? this.informacion_autorizado_legal.numero_nit.state = true
          : this.informacion_autorizado_legal.numero_nit.state = false

        this.informacion_autorizado_legal.numero_dui.value == null ||
        this.informacion_autorizado_legal.numero_dui.value == '' ? this.informacion_autorizado_legal.numero_dui.state = true
          : this.informacion_autorizado_legal.numero_dui.state = false

        this.informacion_autorizado_legal.nacionalidad.value == null ||
        this.informacion_autorizado_legal.nacionalidad.value == '' ? this.informacion_autorizado_legal.nacionalidad.state = true
          : this.informacion_autorizado_legal.nacionalidad.state = false

        this.informacion_autorizado_legal.sexo.value == null ||
        this.informacion_autorizado_legal.sexo.value == '' ? this.informacion_autorizado_legal.sexo.state = true
          : this.informacion_autorizado_legal.sexo.state = false

        this.informacion_autorizado_legal.fecha_nacimiento.value == null ||
        this.informacion_autorizado_legal.fecha_nacimiento.value == '' ? this.informacion_autorizado_legal.fecha_nacimiento.state = true
          : this.informacion_autorizado_legal.fecha_nacimiento.state = false

        this.validData(2, 'primer_nombre')
        this.validData(2, 'segundo_nombre')
        this.validData(2, 'tercer_nombre')
        this.validData(2, 'primer_apellido')
        this.validData(2, 'segundo_apellido')
        this.validData(2, 'apellido_casada')
        this.validData(2, 'fecha_nacimiento')
      }
    },
    registrarPersonaAutorizadaResidente() {
      this.informacion_autorizado_legal.primer_nombre.state = false
      this.informacion_autorizado_legal.segundo_nombre.state = false
      this.informacion_autorizado_legal.tercer_nombre.state = false
      this.informacion_autorizado_legal.primer_apellido.state = false
      this.informacion_autorizado_legal.segundo_apellido.state = false
      this.informacion_autorizado_legal.apellido_casada.state = false
      this.informacion_autorizado_legal.fecha_nacimiento.state = false
      this.validData(2, 'primer_nombre')
      this.validData(2, 'segundo_nombre')
      this.validData(2, 'tercer_nombre')
      this.validData(2, 'primer_apellido')
      this.validData(2, 'segundo_apellido')
      this.validData(2, 'apellido_casada')
      //this.validData(2,'fecha_nacimiento')
      if (this.informacion_autorizado_legal.primer_nombre.value !== null
        && !this.informacion_autorizado_legal.primer_nombre.state
        && !this.informacion_autorizado_legal.segundo_nombre.state
        && !this.informacion_autorizado_legal.tercer_nombre.state
        && !this.informacion_autorizado_legal.primer_apellido.state
        && !this.informacion_autorizado_legal.segundo_apellido.state
        && !this.informacion_autorizado_legal.apellido_casada.state
        && !this.informacion_autorizado_legal.fecha_nacimiento.state
        && this.informacion_autorizado_legal.primer_apellido.value !== null
        && this.informacion_autorizado_legal.nacionalidad.value !== null
        && this.informacion_autorizado_legal.numero_carnet.value !== null
        && this.informacion_autorizado_legal.sexo.value !== null
        && this.informacion_autorizado_legal.fecha_nacimiento.value !== null
        && this.informacion_autorizado_legal.primer_nombre.value !== ''
        && this.informacion_autorizado_legal.primer_apellido.value !== ''
        && this.informacion_autorizado_legal.nacionalidad.value !== ''
        && this.informacion_autorizado_legal.fecha_nacimiento.value !== ''
        && this.informacion_autorizado_legal.sexo.value !== ''
        && this.informacion_autorizado_legal.numero_carnet.value !== '') {
        let id = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
        axios.post(this.url + '/api/v1/personas', {
          "primer_nombre": this.informacion_autorizado_legal.primer_nombre.value,
          "primer_apellido": this.informacion_autorizado_legal.primer_apellido.value,
          "fecha_nacimiento": this.informacion_autorizado_legal.fecha_nacimiento.value,
          "id_sexo": parseInt(this.informacion_autorizado_legal.sexo.value),
          "id_nacionalidad": parseInt(this.informacion_autorizado_legal.nacionalidad.value),
          "id_cargo": 2,
          "activo": true,
          //  "id_institucion": parseInt(id.id),
          "segundo_nombre": this.informacion_autorizado_legal.segundo_nombre.value !== null && this.informacion_autorizado_legal.segundo_nombre.value !== '' &&
          this.informacion_autorizado_legal.segundo_nombre.value.length > 0 ? this.informacion_autorizado_legal.segundo_nombre.value : null,
          "segundo_apellido": this.informacion_autorizado_legal.segundo_apellido.value !== null && this.informacion_autorizado_legal.segundo_apellido.value !== '' &&
          this.informacion_autorizado_legal.segundo_apellido.value.length > 0
            ? this.informacion_autorizado_legal.segundo_apellido.value : null,
          "apellido_casada": this.informacion_autorizado_legal.apellido_casada.value <= 0 ? null : this.informacion_autorizado_legal.apellido_casada.value,
          "dui": this.informacion_autorizado_legal.numero_dui.value ? this.informacion_autorizado_legal.numero_dui.value : null,
          "tercer_nombre": this.informacion_autorizado_legal.tercer_nombre.value <= 0 ? null : this.informacion_autorizado_legal.tercer_nombre.value,
          "nit": this.informacion_autorizado_legal.numero_nit.value ? this.informacion_autorizado_legal.numero_nit.value : null,
          "carne_residente": this.informacion_autorizado_legal.numero_carnet.value ? this.informacion_autorizado_legal.numero_carnet.value : null,
        }).then((response) => {
          if (response.status == 303) {
            this.$toast.error('El numero de NIT ya se encuentra asociado a otra persona')
          } else {
            this.informacion_autorizado_legal.numero_carnet.value = response.data.carnet_residente,
              this.informacion_autorizado_legal.numero_nit.value = response.data.nit,
              this.informacion_autorizado_legal.primer_nombre.value = response.data.primer_nombre,
              this.informacion_autorizado_legal.segundo_nombre.value = response.data.segundo_nombre,
              this.informacion_autorizado_legal.segundo_apellido.value = response.data.segundo_apellido,
              this.informacion_autorizado_legal.tercer_nombre.value = response.data.tercer_nombre,
              this.informacion_autorizado_legal.apellido_casada.value = response.data.apellido_casada,
              this.informacion_autorizado_legal.nacionalidad.value = response.data.id_nacionalidad,
              this.informacion_autorizado_legal.sexo.value = response.data.id_sexo,
              this.informacion_autorizado_legal.cargo.value = 1,
              this.informacion_autorizado_legal.empresa.value = this.informacion_representante.empresa.value,
              this.informacion_autorizado_legal.id_persona = response.data.id,
              this.setLocalStorage_(5)
            this.alert_autorizado_residente = false
          }
        }).catch(error => {
          if (error.response.status == 303) {
            this.$toast.error('El numero de NIT ya se encuentra asociado a otra persona')
          }
          if (error.response.status == 400) {
            this.$toast.error(error.response.data.message)
          }
          error.response.data.errors.forEach(row => {
            if (row.propiedad == 'nit') {
              this.$toast.error('Error en el nit verifique la información ingresada')
            }
          })
          return false;
        })
      } else {
        this.informacion_autorizado_legal.numero_carnet.value == null ||
        this.informacion_autorizado_legal.numero_carnet.value == '' ? this.informacion_autorizado_legal.numero_carnet.state = true
          : this.informacion_autorizado_legal.numero_carnet.state = false

        this.informacion_autorizado_legal.primer_nombre.value == null ||
        this.informacion_autorizado_legal.primer_nombre.value == '' ? this.informacion_autorizado_legal.primer_nombre.state = true
          : this.informacion_autorizado_legal.primer_nombre.state = false


        this.informacion_autorizado_legal.primer_apellido.value == null ||
        this.informacion_autorizado_legal.primer_apellido.value == '' ? this.informacion_autorizado_legal.primer_apellido.state = true
          : this.informacion_autorizado_legal.primer_apellido.state = false


        this.informacion_autorizado_legal.numero_carnet.value == null ||
        this.informacion_autorizado_legal.numero_carnet.value == '' ? this.informacion_autorizado_legal.numero_carnet.state = true
          : this.informacion_autorizado_legal.numero_carnet.state = false

        this.informacion_autorizado_legal.nacionalidad.value == null ||
        this.informacion_autorizado_legal.nacionalidad.value == '' ? this.informacion_autorizado_legal.nacionalidad.state = true
          : this.informacion_autorizado_legal.nacionalidad.state = false

        this.informacion_autorizado_legal.sexo.value == null ||
        this.informacion_autorizado_legal.sexo.value == '' ? this.informacion_autorizado_legal.sexo.state = true
          : this.informacion_autorizado_legal.sexo.state = false

        this.informacion_autorizado_legal.fecha_nacimiento.value == null ||
        this.informacion_autorizado_legal.fecha_nacimiento.value == '' ? this.informacion_autorizado_legal.fecha_nacimiento.state = true
          : this.informacion_autorizado_legal.fecha_nacimiento.state = false

        this.validData(2, 'primer_nombre')
        this.validData(2, 'segundo_nombre')
        this.validData(2, 'tercer_nombre')
        this.validData(2, 'primer_apellido')
        this.validData(2, 'segundo_apellido')
        this.validData(2, 'apellido_casada')
        //this.validData(2,'fecha_nacimiento')
      }
    },
    verificarDocumento(dato, tipo) {
      if ((dato == null || dato == '') && tipo == 2) {
        this.informacion_autorizado_legal.correo_empresa.value = null
        this.informacion_autorizado_legal.correo_empresa.disabled = false
        this.flag = false
        this.informacion_autorizado_legal.telefonos.value = [];

      }

      let id = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
      if (tipo == 1 && this.informacion_representante.numero_dui.value !== null && this.informacion_representante.numero_dui.value !== '') {
        this.informacion_representante.numero_nit.value = null
        this.informacion_representante.primer_nombre.value = null
        this.informacion_representante.segundo_nombre.value = null
        this.informacion_representante.segundo_apellido.value = null
        this.informacion_representante.tercer_nombre.value = null
        this.informacion_representante.apellido_casada.value = null
        this.informacion_representante.sexo.value = null
        this.informacion_representante.cargo.value = null
        this.informacion_representante.empresa.value = null
        this.informacion_representante.id_persona = null
        this.informacion_representante.id_persona = 0
        this.nitrepresentante = null
        this.nombre = 'representante legal'

        axios.get(this.url + '/api/v1/personas?dui=' + dato + '&id_empresa=' + id.id).then((response) => {
          if (response.data.length === 0) {
            this.alert = true


            //this.informacion_representante.numero_dui.value = null
          } else {

            if (response.data[0].disponible_empresa) {
              if(response.data[0].nit != null || response.data[0].nit != '')
              {
                this.foundWithNit = response.data[0].nit.length > 10
                this.nitrepresentante =response.data[0].nit
              }
              this.informacion_representante.numero_dui.value2 = response.data[0].dui
              this.informacion_representante.numero_dui.value = response.data[0].dui
              this.duirepresentante = response.data[0].dui
              this.informacion_representante.id_persona = response.data[0].id
              this.nitrepresentante = response.data[0].nit
              this.informacion_representante.numero_nit.value = response.data[0].nit
              //this.informacion_representante.foto_dui.value =response.data[0].foto_dui
              //this.informacion_representante.foto_nit.value =response.data[0].foto_nit
              this.setLocalStorage_(4)
            } else {
              this.$toast.error('El número de documento ya se encuentra asociado a una institución')
              this.informacion_representante.numero_dui.value = null
              return false
            }
          }
        }).catch(error => {
          if (error.response.status == 400) {
            this.$toast.warning('Formato de dui incorrecto')
            this.informacion_representante.numero_dui.value = null
            return false
          }
        })
      }
      if (tipo == 2 && this.informacion_autorizado_legal.numero_dui.value !== null && this.informacion_autorizado_legal.numero_dui.value !== '') {
        this.nombre = 'autorizado'
        this.informacion_autorizado_legal.numero_nit.value = null
        this.informacion_autorizado_legal.primer_nombre.value = null
        this.informacion_autorizado_legal.segundo_nombre.value = null
        this.informacion_autorizado_legal.segundo_apellido.value = null
        this.informacion_autorizado_legal.tercer_nombre.value = null
        this.informacion_autorizado_legal.apellido_casada.value = null
        this.informacion_autorizado_legal.sexo.value = null
        this.informacion_autorizado_legal.cargo.value = null
        this.informacion_autorizado_legal.empresa.value = null
        this.informacion_autorizado_legal.id_persona = null

        axios.get(this.url + '/api/v1/personas?dui=' + dato + '&id_empresa=' + id.id).then((response) => {
          if (response.data.length === 0) {
            this.alert_autorizado = true
            this.informacion_autorizado_legal.telefonos.value = [];
            this.informacion_autorizado_legal.correo_empresa.value = null;
            this.informacion_autorizado_legal.correo_empresa.disabled = false
            this.setLocalStorage_(5)
            //  this.informacion_autorizado_legal.numero_dui.value=null
          } else {
            if (response.data[0].disponible_empresa) {
              this.informacion_autorizado_legal.numero_dui.value = response.data[0].dui
              this.informacion_autorizado_legal.numero_dui.value2 = response.data[0].dui
              this.informacion_autorizado_legal.id_persona = response.data[0].id

              this.getDataPersonaContacto(response.data[0].id)

              this.setLocalStorage_(5)

            } else {
              this.informacion_autorizado_legal.correo_empresa.disabled = false
              this.informacion_autorizado_legal.numero_dui.value = null
              this.$toast.error('El número de documento ya se encuentra asociado a una institución')
              return false

            }

          }
        }).catch(error => {
          if (error.response.status == 400) {
            this.$toast.error('Formato de dui incorrecto')
            this.informacion_autorizado_legal.numero_dui.value = null
            this.informacion_autorizado_legal.correo_empresa.disabled = false
            return false;
          }
        })
      } else if (tipo == 2 && this.informacion_autorizado_legal.numero_dui.value == null) {
        this.flag = false
        this.informacion_autorizado_legal.correo_empresa.disabled = false
        this.informacion_autorizado_legal.telefonos.value = [];
      }
      if (tipo == 3 && this.informacion_autorizado_legal.numero_carnet.value !== null && this.informacion_autorizado_legal.numero_carnet.value !== '') {
        this.nombre = 'autorizado'
        this.informacion_autorizado_legal.numero_nit.value = null
        this.informacion_autorizado_legal.primer_nombre.value = null
        this.informacion_autorizado_legal.segundo_nombre.value = null
        this.informacion_autorizado_legal.segundo_apellido.value = null
        this.informacion_autorizado_legal.tercer_nombre.value = null
        this.informacion_autorizado_legal.apellido_casada.value = null
        this.informacion_autorizado_legal.sexo.value = null
        this.informacion_autorizado_legal.cargo.value = null
        this.informacion_autorizado_legal.empresa.value = null
        this.informacion_autorizado_legal.id_persona = null


        axios.get(this.url + '/api/v1/personas?carne_residente=' + dato + '&id_empresa=' + id.id).then((response) => {
          if (response.data.length === 0) {
            this.alert_autorizado_residente = true
            this.informacion_autorizado_legal.telefonos.value = [];
            this.informacion_autorizado_legal.correo_empresa.value = null;
            this.informacion_autorizado_legal.correo_empresa.disabled = false
            this.flag = false
            this.setLocalStorage_(5)
            //  this.informacion_autorizado_legal.numero_dui.value=null
          } else {
            if (response.data[0].disponible_empresa) {

              this.informacion_autorizado_legal.numero_carnet.value2 = response.data[0].carne_residente

              this.informacion_autorizado_legal.id_persona = response.data[0].id

              this.getDataPersonaContacto(response.data[0].id)

              this.setLocalStorage_(5)

            } else {
              this.flag = false
              this.informacion_autorizado_legal.correo_empresa.disabled = false
              this.informacion_autorizado_legal.numero_carnet.value = null
              this.$toast.error('El número de documento ya se encuentra asociado a una institución')
              return false

            }

          }
        }).catch(error => {
          if (error.response.status == 400) {
            this.$toast.error('Formato de dui incorrecto')
            this.informacion_autorizado_legal.numero_dui.value = null
            this.informacion_autorizado_legal.correo_empresa.disabled = false
            return false;
          }
        })
      } else if (tipo == 2 && this.informacion_autorizado_legal.numero_dui.value == null) {
        this.informacion_autorizado_legal.correo_empresa.disabled = false
        this.flag = false
        this.informacion_autorizado_legal.telefonos.value = [];
      }
      if (tipo == 4 && this.informacion_representante.numero_carnet.value !== null && this.informacion_representante.numero_carnet.value !== '') {
        this.informacion_representante.numero_nit.value = null
        this.informacion_representante.primer_nombre.value = null
        this.informacion_representante.segundo_nombre.value = null
        this.informacion_representante.segundo_apellido.value = null
        this.informacion_representante.tercer_nombre.value = null
        this.informacion_representante.apellido_casada.value = null
        this.informacion_representante.sexo.value = null
        this.informacion_representante.cargo.value = null
        this.informacion_representante.empresa.value = null
        this.informacion_representante.id_persona = null
        this.informacion_representante.id_persona = 0
        this.nitrepresentante = null
        this.nombre = 'representante legal'

        axios.get(this.url + '/api/v1/personas?carne_residente=' + dato + '&id_empresa=' + id.id).then((response) => {
          if (response.data.length === 0) {
            if (this.informacion_representante.numero_carnet.value !== null) {
              this.alert_residente = true
            }

            //this.informacion_representante.numero_dui.value = null
          } else {

            if (response.data[0].disponible_empresa) {
              this.informacion_representante.numero_carnet.value2 = response.data[0].carne_residente
              //this.duirepresentante = response.data[0].car
              this.informacion_representante.id_persona = response.data[0].id
              this.nitrepresentante = response.data[0].nit
              this.informacion_representante.numero_nit.value = this.nitrepresentante
              this.informacion_representante.foto_dui.value = response.data[0].foto_dui
              this.informacion_representante.foto_nit.value = response.data[0].foto_nit
              this.setLocalStorage_(4)
            } else {
              this.$toast.error('El número de documento ya se encuentra asociado a una institución')
              this.informacion_representante.numero_carnet.value2 = null
              return false
            }
          }
        }).catch(error => {
          if (error.response.status == 400) {
            this.$toast.warning('Formato de dui incorrecto')
            this.informacion_representante.numero_dui.value = null
            return false
          }
        })
      }
    },
    ShowInputs() {
      if (this.tipodoc == 1) {
        this.mostrar_dui = true
        this.mostrar_residencia = false
        this.mostrar_inputs = true
      } else if (this.tipodoc == 2) {
        this.mostrar_residencia = true
        this.mostrar_dui = false
        this.mostrar_inputs = true
      }

    },

    ShowInputsRL() {
      if (this.tipodocRl == 1) {
        this.mostrar_duiRL = true
        this.mostrar_residenciaRL = false
        this.mostrar_inputsRL = true
        this.informacion_representante.numero_carnet.value = null
        //this.LimpiarFormRL()
      } else if (this.tipodocRl == 2) {
        this.mostrar_residenciaRL = true
        this.mostrar_duiRL = false
        this.mostrar_inputsRL = false
        this.informacion_representante.numero_dui.value = null
        this.informacion_representante.numero_nit.value = null
        //this.LimpiarFormRL()
        this.informacion_representante_props.numero_dui.state = null
        this.informacion_representante_props.numero_nit.state = null
        this.informacion_representante_props.foto_dui.state = null
        this.informacion_representante_props.foto_nit.state = null
      }

    },

    async getDataPersonaContacto(id_persona) {
      if (!this.informacion_autorizado_legal.numero_dui.value) {

        this.informacion_autorizado_legal.telefonos.value = [];
        this.informacion_autorizado_legal.correo_empresa.value = null;
      }
      if (!this.informacion_autorizado_legal.numero_carnet.value) {

        this.informacion_autorizado_legal.telefonos.value = [];
        this.informacion_autorizado_legal.correo_empresa.value = null;
        this.informacion_autorizado_legal.correo_empresa.disabled = false
      }
      const response = await this.http_client('/api/v1/personas/' + id_persona + '/contactos')
      let telefonos = []
      response.data.forEach(row => {
        if (row.id_tipo_contacto == 2) {
          this.informacion_autorizado_legal.correo_empresa.value = row.contacto
          if (this.informacion_autorizado_legal.correo_empresa.value !== null) {
            this.informacion_autorizado_legal.correo_empresa.disabled = true
            this.flag = true
          }

        } else if (row.id_tipo_contacto == 1) {
          telefonos.push({'Telefono': row.contacto, 'id': row.id})
        }
      })
      if (telefonos.length > 0) {
        this.informacion_autorizado_legal.telefonos.value = telefonos
      }

    },
    addTelefono(id, id_telefono) {
      if (id == null) {
        if (this.informacion_autorizado_legal.telefonos.value.length < 3) {
          if (this.numerosTelefono.charAt(0) == 6 || this.numerosTelefono.charAt(0) == 7 || this.numerosTelefono.charAt(0) == 2) {
            if (this.numerosTelefono && this.numerosTelefono !== null && this.numerosTelefono.trim() !== '' && this.numerosTelefono.trim().length >= 8
              && this.numerosTelefono.trim().length <= 9) {
              let cadena_a_comprobar = this.numerosTelefono
              let valoresAceptadosInt = /^[0-9]+$/;
              let valoresAceptadosGuion = /^\d{4}-\d{4}$/;
              if (cadena_a_comprobar.match(valoresAceptadosInt) || cadena_a_comprobar.match(valoresAceptadosGuion)) {
                let textoActual = this.numerosTelefono.trim();
                const isCelular = textoActual.length === 10 || textoActual.length === 11;
                let textoAjustado;
                textoAjustado = textoActual.replace(/\-/g, '');
                textoActual = textoAjustado;
                if (isCelular) {
                  const parte1 = textoActual.slice(0, 5);
                  const parte2 = textoActual.slice(5, 9);
                  textoAjustado = `${parte1}-${parte2}`
                } else {
                  const parte1 = textoActual.slice(0, 4);
                  const parte2 = textoActual.slice(4, 8);
                  textoAjustado = `${parte1}-${parte2}`
                }
                this.numerosTelefono = textoAjustado.trim();
                let arrTelefono = this.informacion_autorizado_legal.telefonos.value

                if (arrTelefono.length == 0 && arrTelefono.length <= 1) {
                  this.informacion_autorizado_legal.telefonos.value.push({'Telefono': this.numerosTelefono.replace(/ /g, "")})
                } else {
                  let numeroExiste = arrTelefono.find(Telefono => Telefono.Telefono === this.numerosTelefono);
                  if (!numeroExiste) {
                    this.informacion_autorizado_legal.telefonos.value.push({'Telefono': this.numerosTelefono.replace(/ /g, "")})
                  }
                }
                this.setLocalStorage_(5)
              } else {
              }
            }
          } else {
            this.$toast.error('numero de teléfono incorrecto')
            return false
          }
        } else {
          this.$toast.error('Solo se permiten ingresar 3 números de teléfono')
          return false
        }
      } else {
        id_telefono > 0 ? this.deleteTelefonos(id_telefono) : ''
        this.informacion_autorizado_legal.telefonos.value.splice(id.index, 1)
        this.setLocalStorage_(5)
        //this.$store.dispatch('empresas/setInfoEmpresa')
      }
      this.numerosTelefono = null
    },
    deleteTelefonos(id) {
//      if (this.informacion_autorizado_legal.id_persona>0){
      axios.delete(this.url + '/api/v1/personas/' + this.informacion_autorizado_legal.id_persona + '/contactos/' + id).then((response) => {
      });
//     }
    },
    setLocalStorage_(tipo) {
      this.$store.dispatch('Fodes/setData',
        {
          'informacion_representante': this.informacion_representante,
          'informacion_autorizado_legal': this.informacion_autorizado_legal, 'tipo': tipo
        })
    },
    getPaises() {
      axios.get(this.url + '/api/v1/nacionalidades',
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }).then((response) => {
        this.pais_origen_options = response.data
      });
    },
    getSexos() {
      axios.get(this.url + '/api/v1/sexos',
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }).then((response) => {
        this.sexos_options = response.data
      });
    },
    getDatosFormulario() {

      let InfoEmpresa = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
      if (InfoEmpresa.representante_legal && InfoEmpresa.autorizado_legal) {
        if (InfoEmpresa.representante_legal[0]) {
          if (InfoEmpresa.representante_legal[0].dui === null) {
            this.mostrar_residenciaRL = true
            this.tipodocRl = 2
            this.mostrar_inputsRL = true
            this.flagRL = true
            this.informacion_representante.foto_carnet.value = 'true'
            this.informacion_representante.numero_carnet.value = InfoEmpresa.representante_legal[0].carne_residente
            this.verificarDocumento(InfoEmpresa.representante_legal[0].carne_residente, 4)
          } else {
            this.mostrar_duiRL = true
            this.tipodocRl = 1
            this.mostrar_inputsRL = true
            this.flagRL = true
            this.informacion_representante.foto_dui.value = 'true'
            this.informacion_representante.foto_nit.value = 'true'
            this.informacion_representante.numero_dui.value = InfoEmpresa.representante_legal[0].dui
            this.duirepresentante = InfoEmpresa.representante_legal[0].dui
            this.verificarDocumento(InfoEmpresa.representante_legal[0].dui, 1)
          }

        }
        if (InfoEmpresa.autorizado_legal[0]) {
          if (InfoEmpresa.autorizado_legal[0].dui === null) {
            this.mostrar_residencia = true
            this.tipodoc = 2
            this.mostrar_inputs = true
            this.informacion_autorizado_legal.numero_carnet.value = InfoEmpresa.autorizado_legal[0].carne_residente
            this.verificarDocumento(InfoEmpresa.autorizado_legal[0].carne_residente, 3)
          } else {
            this.mostrar_inputs = true
            this.mostrar_dui = true
            this.tipodoc = 1
            this.informacion_autorizado_legal.numero_dui.value = InfoEmpresa.autorizado_legal[0].dui
            this.duiautorizado = InfoEmpresa.autorizado_legal[0].dui
            this.verificarDocumento(InfoEmpresa.autorizado_legal[0].dui, 2)
          }

        }
      } else {
        let InfoEmpresa = JSON.parse(window.localStorage.getItem('InfoEmpresas'))
      }

      this.infoPersonaRepresentante = JSON.parse(window.localStorage.getItem('informacion_representante'))
      this.infoPersonaLegal = JSON.parse(window.localStorage.getItem('informacion_autorizado_legal'))
      if (this.infoPersonaRepresentante && this.infoPersonaRepresentante.length !== 0) {
        this.duirepresentante = this.infoPersonaRepresentante.numero_dui.value
        this.nitrepresentante = this.infoPersonaRepresentante.numero_nit.value
        this.informacion_representante.foto_nit.value = this.infoPersonaRepresentante.foto_nit.value
        this.informacion_representante.foto_dui.value = this.infoPersonaRepresentante.foto_dui.value
        this.informacion_representante.numero_dui.value = this.infoPersonaRepresentante.numero_dui.value
        //this.informacion_representante = this.infoPersonaRepresentante
      }
      if (this.infoPersonaLegal && this.infoPersonaLegal.length !== 0) {
        //this.informacion_autorizado_legal = this.infoPersonaLegal
        this.duiautorizado = this.infoPersonaLegal.numero_dui.value
        this.informacion_autorizado_legal.numero_dui.value = this.infoPersonaLegal.numero_dui.value
        this.informacion_autorizado_legal.id_persona = this.infoPersonaLegal.id_persona
        this.infoPersonaLegal.correo_empresa.value !== null ?
          this.infoPersonaLegal.correo_empresa.value.length !== 0 ? this.informacion_autorizado_legal.correo_empresa.value = this.infoPersonaLegal.correo_empresa.value : null
          : false
        this.infoPersonaLegal.correo_empresa.id && this.infoPersonaLegal.correo_empresa.id !== null ?
          this.infoPersonaLegal.correo_empresa.id.length !== 0 ? this.informacion_autorizado_legal.correo_empresa.id = this.infoPersonaLegal.correo_empresa.id : null
          : false
        this.infoPersonaLegal.telefonos.value.length !== 0 ? this.informacion_autorizado_legal.telefonos.value = this.infoPersonaLegal.telefonos.value : null
      }

    },
    fotonit_(foto) {
      const extensiones_permitidas = /(.jpg|.jpeg|.pdf)$/i
      if (!extensiones_permitidas.exec(foto.name) || (foto.size > 10485760)) {
        this.$toast.error('solo puedes subir archivos de formato jpg, jpeg y pdf maximo 10MB')
        this.fotonit = null
        this.$store.dispatch('Fodes/setDataFotos', {'fotornc': [], 'tipo': 4})
        this.informacion_representante.foto_nit.value = null
        return false;
      } else {
        this.fotonit = foto.name
        this.informacion_representante.foto_nit.value
        this.$store.dispatch('Fodes/setDataFotos', {'fotonitpersona': foto, 'tipo': 4})
      }
    },
    fotocarnet_(foto) {
      const extensiones_permitidas = /(.jpg|.jpeg|.pdf)$/i
      if (!extensiones_permitidas.exec(foto.name) || (foto.size > 10485760)) {
        this.$toast.error('solo puedes subir archivos de formato jpg, jpeg y pdf maximo 10MB')
        this.fotocarnet = null
        this.$store.dispatch('Fodes/setDataFotos', {'fotornc': [], 'tipo': 6})
        this.informacion_representante.foto_nit.value = null
        return false;
      } else {
        this.fotocarnet = foto.name
        this.$store.dispatch('Fodes/setDataFotos', {'fotocarnetpersona': foto, 'tipo': 6})
      }
    },
    fotodui_(foto) {
      const extensiones_permitidas = /(.jpg|.jpeg|.pdf)$/i
      if (!extensiones_permitidas.exec(foto.name) || (foto.size > 10485760)) {
        this.$toast.error('solo puedes subir archivos de formato jpg, jpeg y pdf máximo 10MB')
        this.fotodui = null
        this.$store.dispatch('Fodes/setDataFotos', {'fotornc': [], 'tipo': 5})
        this.informacion_representante.foto_dui.value = null
        return false;
      } else {
        this.fotodui = foto.name
        //this.informacion_representante.foto_nit.value
        this.$store.dispatch('Fodes/setDataFotos', {'fotoduipersona': foto, 'tipo': 5})
      }
    },
  },
  mounted() {
    this.getPaises()
    this.getSexos()
    this.getDatosFormulario()


  },
  computed: {
    ...mapGetters({
      DataFormulario: "Fodes/getLocalStorage_",
      URL: "getURL",
      isnitvalid: "Fodes/getIsNitValid",
    }),
    correo_autorizado() {
      return this.informacion_autorizado_legal.correo_empresa.value
    },
    dui_representante() {
      return this.informacion_representante.numero_dui.value
    },
    dui_autorizado() {
      return this.informacion_autorizado_legal.numero_dui.value
    },
    carnet_representante() {
      return this.informacion_representante.numero_carnet.value
    }
    ,
    carnet_autorizado() {
      return this.informacion_autorizado_legal.numero_carnet.value
    }
  },
  watch: {
    dui_representante() {
      if (this.informacion_representante.numero_dui.value !== null) {
        if (this.informacion_representante.numero_dui.value.length === 10) {
          this.verificarDocumento(this.informacion_representante.numero_dui.value, 1)
        }
      }
    },
    /*
     carnet_representante(){
       if (this.informacion_representante.numero_carnet.value!==null) {
         if (this.informacion_representante.numero_carnet.value.length >= 8  && this.alert_residente == false) {
           this.verificarDocumento(this.informacion_representante.numero_carnet.value, 4)
         }
       }
     },
     carnet_autorizado(){
       if (this.informacion_autorizado_legal.numero_carnet.value!==null) {
         if (this.informacion_autorizado_legal.numero_carnet.value.length >= 8) {
           this.verificarDocumento(this.informacion_autorizado_legal.numero_carnet.value, 3)
         }
       }
     },

     */
    alert_autorizado: function (val) {
      if (!this.bandera === null) {
        this.informacion_autorizado_legal.numero_dui.value = null
        this.informacion_autorizado_legal.correo_empresa.value = null
      }
    },
    dui_autorizado() {
      if (this.informacion_autorizado_legal.numero_dui.value !== null) {
        if (this.informacion_autorizado_legal.numero_dui.value.length === 10) {
          this.verificarDocumento(this.informacion_autorizado_legal.numero_dui.value, 2)
        }
      }
    },
    correo_autorizado: function () {
      try {
        if (this.correo_autorizado.length > 0) {
          this.setLocalStorage_(5)
          this.isEmailValid()
        }
      } catch (e) {

      }
    },
    numerosTelefono: function (val) {
      if (val > 0) {
        this.numerosTelefono = this.numerosTelefono.replace(/^([^\d\-])/, '')
        this.numerosTelefono = this.numerosTelefono.replace(/^([0-9]{4}-)([0-9]{4})([0-9]*)$/, '$1$2')
        this.numerosTelefono = this.numerosTelefono.replace(/^([0-9]{4})([0-9])$/, '$1-$2')
      }
    },
    nitrepresentante: function (val) {
      if (val !== null && val !== '' && this.poseeNIT === 'SI') {
        this.informacion_representante.numero_nit.value = this.nitrepresentante
        if (this.nitrepresentante.length == 17) {
          this.$store.dispatch('Fodes/viewIsNITvalid', this.nitrepresentante)
          if (this.isnitvalid === false) {
            this.$toast.error('NIT invalido')
            this.nitrepresentante = null
            this.informacion_representante.numero_nit.value = null
            return false
          }
        }
      }
        if (this.poseeNIT === 'NO'){
          this.nitrepresentante.value = this.informacion_representante.numero_dui.value
        }

    },
    /*    duirepresentante: function () {
          if (this.duirepresentante!==null){
            let regex = /[0-9-]+$/;
            if (this.duirepresentante.match(regex)){
              if (this.duirepresentante.length>0){
                this.duirepresentante = this.duirepresentante.replace(/[^\d\-]/, '')
                this.duirepresentante = this.duirepresentante.replace(/^([0-9]{8})([1-9])$/g, "$1-$2")
                this.duirepresentante = this.duirepresentante.replace(/^([0-9]{8}-)([1-9])([0-9]*)$/, "$1$2")
                this.informacion_representante.numero_dui.value = this.duirepresentante
                if (this.duirepresentante.length===10){
                  this.verificarDocumento(this.duirepresentante,1)
                }
              }
            }else {
              this.duirepresentante = null
              this.informacion_representante.numero_dui.value = null
              this.alerts.message = 'formato incorrecto'
              this.alerts.show = true
              setTimeout(() => {
                this.alerts.show = false
              },3500)
            }
          }
        },
        duiautorizado: function () {
          if (this.duiautorizado!==null){
            let regex = /[0-9-]+$/;
            if (this.duiautorizado.match(regex)){
              this.duiautorizado = this.duiautorizado.replace(/[^\d\-]/, '')
              this.duiautorizado = this.duiautorizado.replace(/^([0-9]{8})([1-9])$/g, "$1-$2")
              this.duiautorizado = this.duiautorizado.replace(/^([0-9]{8}-)([1-9])([0-9]*)$/, "$1$2")
              this.informacion_autorizado_legal.numero_dui.value = this.duiautorizado
              if (this.duiautorizado.length===10){
                this.verificarDocumento(this.duiautorizado,2)
              }
            }else{
              this.duiautorizado = null
              this.informacion_autorizado_legal.numero_dui.value = null
              this.alerts.message = 'formato incorrecto'
              this.alerts.show = true
              setTimeout(() => {
                this.alerts.show = false
              },3500)
            }
          }
        },*/
    nitautorizado: function (val) {
      /*      if (val!==null && val!==''){
              this.nitautorizado = this.nitautorizado.replace(/^([^\d\-])/, '')
              this.nitautorizado = this.nitautorizado.replace(/([0-9]{4}-)+([0-9]{6}-)+([0-9]{3}-)([0-9])([0-9]*)$/, '$1$2$3$4')
              this.nitautorizado = this.nitautorizado.replace(/^([0-9]{4}-)([0-9]{6}-)([0-9]{3})([0-9])$/, '$1$2$3-$4')
              this.nitautorizado = this.nitautorizado.replace(/^([0-9]{4}-)([0-9]{6})([0-9])$/, '$1$2-$3')
              this.nitautorizado = this.nitautorizado.replace(/^([0-9]{4})([0-9])$/, '$1-$2')
              this.informacion_autorizado_legal.numero_nit.value = this.nitautorizado*/
      this.informacion_autorizado_legal.numero_nit.value = this.nitautorizado
      let nit = this.nitautorizado
      let valido = false;
      if (nit.length === 17) {
        if (nit !== '0000-000000-000-0' && nit.match(/^[0-9]{4}-[0-9]{6}-[0-9]{3}-[0-9]$/)) {
          // Validando que no sea ceros todos los dígitos
          // Obteniendo los dígitos y el verificador por separado
          let [ubicacion, fecha, correlativo, validador] = nit.split('-');
          let digitos = (ubicacion + fecha + correlativo).split('');
          // Convirtiendo los datos a tipo integer
          validador = parseInt(validador, 10);
          correlativo = parseInt(correlativo, 10);
          let suma = 0;
          let mod = 0;
          if (correlativo <= 100) {
            // Obteniendo la suma corresponiente
            suma = digitos.reduce((total, digito, index) => {
              return total += (parseInt(digito, 10) * (14 - index))
            }, 0);
            // Obteniendo el Modulo base 11
            mod = suma % 11;
            mod = mod === 10 ? 0 : mod;
          } else {
            // Obteniendo la suma corresponiente
            suma = digitos.reduce((total, digito, index) => {
              return total += (parseInt(digito, 10) * parseInt((3 + 6 * Math.floor((index + 5) / 6)) - (index + 1), 10))
            }, 0);
            mod = suma % 11;
            // Obteniendo el Modulo base 11
            mod = mod > 1 ? (11 - mod) : 0;
          }
          if (mod === validador) {
            valido = true;
          } else {
            valido = false;
            this.$toast.error('NIT invalid')
            this.nitautorizado = null
            this.informacion_autorizado_legal.numero_nit.value = null
            return false
          }
        }
      }
    }
  },
  /*  }*/
}

</script>
